import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  HostListener,
  resource,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MbscDateType,
  MbscModule,
  MbscPopupOptions,
} from '@mobiscroll/angular';
import {
  formatDate,
  MbscCalendarEvent,
  MbscEventcalendar,
  Notifications,
} from '@mobiscroll/angular';
import { FetchUserService } from '../../../services/fetchServices/fetchUser/fetch-user.service';
import { firstValueFrom, Subject, Subscription, takeUntil } from 'rxjs';
import { Resource } from '../../../interfaces/resource';
import { GETEventService } from '../../../services/fetchServices/fetchEvent/GET/get-event.service';
import { EventViewComponent } from '../../shared/event-view/event-view.component';
import { EventHoverComponent } from '../../shared/event-hover/event-hover.component';
import { getCalendarOptions } from '../../../interfaces/calender/admin/calender-event-functions';
import { ToastNotificationService } from '../../../services/shared/toast-notification.service';
import { GetBlockerService } from '../../../services/fetchServices/fetchEvent/GET/get-blocker.service';
import { StatusPopupComponent } from '../../shared/popups/status-popup/status-popup.component';
import { WebSocketService } from '../../../services/web-socket.service';
import { PUTEventService } from '../../../services/fetchServices/fetchEvent/PUT/put-event.service';
import { DELETEEventService } from '../../../services/fetchServices/fetchEvent/DELETE/delete-event.service';
import { FilterResourcesService } from '../../../services/filter-resources.service';
import { FilterResourcesPopupComponent } from '../../../filter-resources-popup/filter-resources-popup.component';
import { ThemeService } from '../../../services/shared/theme.service';
import { EventHistoryService } from '../../../services/shared/event-history/event-history.service';
import { EventUtilsService } from '../../../services/shared/event-utils/event-utils.service';
import { POSTEventService } from '../../../services/fetchServices/fetchEvent/POST/post-event.service';
import { PermissionService } from '../../../services/permission.service';
import { GetTraveltimeService } from '../../../services/fetchServices/fetchTraveltime/POST/get-traveltime.service';
import { LeftSidebarComponent } from '../../shared/sidebar/left-sidebar/sidebar.component';
import { MoveToEventService } from '../../../services/shared/move-to-event/move-to-event.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  typeData,
  statusData,
  teamDataAll,
} from '../../../interfaces/selectData';
import { GetCustomerService } from '../../../services/fetchServices/fetchCustomer/GET/get-customer.service';
import { WeekTemplateComponent } from '../../shared/calendar-template/week-template/week-template.component';
import { ResourceTemplateComponent } from '../../shared/calendar-template/resource-template/resource-template.component';
import { HeaderTemplateComponent } from '../../shared/calendar-template/header-template/header-template.component';
import { EventPopupComponent } from '@tridimo/shared-ui';
import { GetOptionsService } from '../../../services/fetchServices/fetchOptions/GET/get-options.service';
import { PostCustomerService } from '../../../services/fetchServices/fetchCustomer/POST/post-customer.service';
import { ColorService } from '../../../services/shared/color/color.service';
import { DateChangeService } from '../../../services/shared/date-change.service';
import { SidebarComponent } from '@coreui/angular-pro';
import html2canvas from 'html2canvas';
import { EventViewExportComponent } from '../../shared/event-view-export/event-view-export.component';
import { SvgIconService } from '../../../services/shared/icons/svg-icon.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { SkillService } from '../../../services/shared/skill/skill.service';
import { TraveltimeService } from '../../../services/shared/traveltime/traveltime.service';
import { BufferService } from '../../../buffer.service';

type OnlineLinkItem = {
  platform: string;
  link: string;
  description: string;
};

@Component({
  standalone: true,
  selector: 'app-calendar-admin',
  imports: [
    MbscModule,
    CommonModule,
    FormsModule,
    EventViewComponent,
    EventHoverComponent,
    LeftSidebarComponent,
    StatusPopupComponent,
    FilterResourcesPopupComponent,
    WeekTemplateComponent,
    ResourceTemplateComponent,
    HeaderTemplateComponent,
    EventPopupComponent,
    EventViewExportComponent,
  ],
  providers: [Notifications],
  templateUrl: './calendar-admin.component.html',
  styleUrl: './calendar-admin.component.scss',
})
export class CalendarAdminComponent implements OnInit, OnDestroy {
  constructor(
    public fetchUserService: FetchUserService,
    private getEventService: GETEventService,
    private toastService: ToastNotificationService,
    public getBlockerService: GetBlockerService,
    private socketService: WebSocketService,
    public putEventFetchService: PUTEventService,
    public deleteEventFetchService: DELETEEventService,
    public filterResourcesService: FilterResourcesService,
    private cdr: ChangeDetectorRef,
    public themeService: ThemeService,
    private eventHistoryService: EventHistoryService,
    public eventUtils: EventUtilsService,
    private postEventFetchService: POSTEventService,
    private permissionService: PermissionService,
    public traveltimeService: GetTraveltimeService,
    private calendarEventService: MoveToEventService,
    private route: ActivatedRoute,
    private router: Router,
    public getCustomerService: GetCustomerService,
    private getOptionsService: GetOptionsService,
    private postCustomerService: PostCustomerService,
    public colorService: ColorService,
    private dateChangeService: DateChangeService,
    public svgIconService: SvgIconService,
    public http: HttpClient,
    private sanitizer: DomSanitizer,
    public skillService: SkillService,
    public calcTraveltimeService: TraveltimeService,
    public bufferService: BufferService,
  ) {}

  private subscriptions = new Subscription();

  private userResourcesSubscription: Subscription | undefined;
  private interpretersResourcesSubscription: Subscription | undefined;
  private refreshInterval: any;
  private scrollListenerAttached = false;

  public zoomLevel = 1;
  public refDate = this.getRefDate(new Date());

  @Output() travelTimeCalculated = new EventEmitter<any>();

  @ViewChild(EventPopupComponent) sharedEventPopup!: EventPopupComponent;
  @ViewChild(EventHoverComponent) sharedEventHover!: EventHoverComponent;
  @ViewChild(StatusPopupComponent) sharedStatusPopup!: StatusPopupComponent;
  @ViewChild(FilterResourcesPopupComponent)
  filterResourcesPopup!: FilterResourcesPopupComponent;
  @ViewChild('calendar', { static: false }) calendar!: MbscEventcalendar;
  @ViewChild('filterButton') filterButton!: ElementRef;
  @ViewChild('filterButton') anchorElm!: ElementRef;
  @ViewChild('calendar', { read: ElementRef }) calendarEl!: ElementRef;
  @ViewChild('weekTemplateComp') weekTemplateComp!: WeekTemplateComponent;
  @ViewChild('exportCalendar', { read: ElementRef })
  exportCalendar!: ElementRef;
  @ViewChild(LeftSidebarComponent) sidebar!: LeftSidebarComponent;

  formatDate = formatDate;
  calendarOptions = getCalendarOptions(this);
  myData = teamDataAll;
  typeData = typeData;
  popupAnchor: HTMLElement | undefined;
  popupEventTitle: string | undefined;
  popupEventLocation: string | undefined;
  popupEventBill: number | undefined;
  popupEventNotes: string | undefined;
  popupEventDates: any;
  userResources: any[] = [];
  interpreterResources: any[] = [];
  myEvents: MbscCalendarEvent[] = [];
  mySidebarEvents: MbscCalendarEvent[] = [];
  invalids: MbscCalendarEvent[] = [];
  selectedEvent: MbscCalendarEvent[] = [];
  tempEvent: MbscCalendarEvent = {
    title: '',
    start: new Date(),
    end: new Date(),
    resource: '',
  };
  myResources: Resource[] = [];
  mySortedResources: Resource[] = [];
  sortedEvents = [];
  allEvents = [];
  myEventsCopy: MbscCalendarEvent[] = [];
  tempBackgrounds: any[] = [];
  adminResttimes: {
    start: Date;
    end: Date;
    resource: any;
    text: string;
    cssClass: string;
  }[] = [];
  userResttimes: {
    start: Date;
    end: Date;
    resource: any;
    text: string;
    cssClass: string;
  }[] = [];
  selectedKey: string[] = [];
  highlightedTimes: {
    start: Date;
    end: Date;
    resource?: any;
    background?: string;
    text?: string;
    cssClass?: string;
    type?: string;
    id?: number;
  }[] = [];
  highlightedTimesCopy: any = [];
  invalidsCopy: any = [];
  highlightedTimesDragCopy: any = [];
  invalidsDragCopy: any = [];
  popupOptions: MbscPopupOptions = {
    display: 'anchored',
    contentPadding: false,
    focusOnClose: false,
    focusOnOpen: false,
    showOverlay: false,
    width: 400,
  };
  filteredCustomers: any[] = [];
  customersData: any[] = [];
  popupCloseAfterEventDelete: boolean = false;
  popupCloseAfterMoveEventToBacklog: boolean = false;
  popupCloseAfterEventPost: boolean = false;
  popupCloseAfterEventUpdate: boolean = false;
  showTabContainer: boolean = false;
  showInterpreterSelection: boolean = true;
  toggleStatusTemplate: boolean = true;
  toggleStatusBacklog: boolean = true;
  showDeleteButtonsFlag: boolean = false;
  showHistoryContainer: boolean = false;
  dragging: boolean = false;
  ticketBacklogOpen: boolean = true;
  isPopupOpen: boolean = false;
  isEdit: boolean = false;
  originalEventData: any;
  groupedHistory: any;
  event: any;
  today: any;
  inst: any;
  selectedDate: any;
  customerArray: any;
  startOfDay = new Date();
  endOfDay = new Date();
  selectedSegment: any;
  newlyCreatedCustomer: any;
  yesterday: any;
  myStats: any;
  historyData: any[] = [];
  savedScrollTop: number = 0;
  weekNumber: number = 0;
  lastLoadedDate: number | null = null;
  travelTimeData: any = null;
  stammteamData: any[] = [];
  statusData = statusData;
  isDarkMode: boolean = false;
  tasks: any = [];
  filteredTasks: any = [];
  oldResource: number | undefined;
  newResource: number | undefined;
  blockerInvalids: any;
  lastVisibleTime: any;
  extResources: any[] = [];
  responseEvent: any;
  ignoreId: any;
  onlyMetaChange = false;
  private lastCollapsedState: Record<string, boolean> = {};
  private destroy$ = new Subject<void>();
  exportCalendarOptions: any;

  //SCREENSHOT
  exportEvents: any[] = [];
  exportColors: any[] = [];
  exportResources: any[] = [];
  isExporting = false;

  private pendingUpdates = new Map<string | number, number>();

  @HostListener('wheel')
  onWheel(): void {
    this.sharedEventHover?.closePopupOnScroll();
  }

  @HostListener('touchmove')
  onTouchMove(): void {
    this.sharedEventHover?.closePopupOnScroll();
  }

  // KALENDER GRUPPEN EIN- UND AUSKLAPPEN
  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    //ALLGEMEIN
    if (event.ctrlKey && event.key.toLowerCase() === 'a') {
      event.preventDefault();
      const collapsedTeams = JSON.parse(
        localStorage.getItem('collapsedTeams') || '[]',
      );
      const isCollapsed = collapsedTeams.includes('Allgemein');
      if (isCollapsed) {
        const updatedCollapsedTeams = collapsedTeams.filter(
          (team: string) => team !== 'Allgemein',
        );
        localStorage.setItem(
          'collapsedTeams',
          JSON.stringify(updatedCollapsedTeams),
        );
      } else {
        collapsedTeams.push('Allgemein');
        localStorage.setItem('collapsedTeams', JSON.stringify(collapsedTeams));
      }
      this.applyCollapsedTeams();
    }

    //CHEF + DOLMETSCHER
    if (event.ctrlKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      const collapsedTeams = JSON.parse(
        localStorage.getItem('collapsedTeams') || '[]',
      );
      const isCollapsed = collapsedTeams.some((team: string) =>
        ['Chef', 'Dolmetscher'].includes(team),
      );
      if (isCollapsed) {
        const updatedCollapsedTeams = collapsedTeams.filter(
          (team: string) => !['Chef', 'Dolmetscher'].includes(team),
        );
        localStorage.setItem(
          'collapsedTeams',
          JSON.stringify(updatedCollapsedTeams),
        );
      } else {
        collapsedTeams.push('Chef', 'Dolmetscher');
        localStorage.setItem('collapsedTeams', JSON.stringify(collapsedTeams));
      }
      this.applyCollapsedTeams();
    }

    //BÜRO
    if (event.ctrlKey && event.key.toLowerCase() === 'b') {
      event.preventDefault();
      const collapsedTeams = JSON.parse(
        localStorage.getItem('collapsedTeams') || '[]',
      );
      const isCollapsed = collapsedTeams.includes('Büro');
      if (isCollapsed) {
        const updatedCollapsedTeams = collapsedTeams.filter(
          (team: string) => team !== 'Büro',
        );
        localStorage.setItem(
          'collapsedTeams',
          JSON.stringify(updatedCollapsedTeams),
        );
      } else {
        collapsedTeams.push('Büro');
        localStorage.setItem('collapsedTeams', JSON.stringify(collapsedTeams));
      }
      this.applyCollapsedTeams();
    }
  }

  doScreenshot(event: any) {
    this.isExporting = true;
    const exportResources = event.memberIds;
    const team = event.team;
    const selected = new Date(this.selectedDate);

    //PASSENDE EVENTS FÜR DIE IDS DER TEAM-MITGLIEDER FINDEN
    const exportEvents = this.myEvents.filter((event) => {
      //RESSOURCEN PRÜFEN
      const resources = Array.isArray(event.resource)
        ? event.resource
        : [event.resource];

      const hasResource = resources.some((id) =>
        exportResources.includes(Number(id)),
      );

      if (!hasResource || !event.start) {
        return false;
      }

      //EVENT-START
      const start =
        event.start instanceof Date
          ? event.start
          : new Date(event.start as string);

      //EVENT GLEICH MIT SELECTED DATE?
      const sameDay =
        start.getFullYear() === selected.getFullYear() &&
        start.getMonth() === selected.getMonth() &&
        start.getDate() === selected.getDate();

      return sameDay;
    });

    //PASSENDE COLORS FÜR DIE IDS DER TEAM-MITGLIEDER FINDEN
    const exportHighlightedTimes = this.highlightedTimes.filter((event) => {
      //RESSOURCEN PRÜFEN
      const hasResource =
        Array.isArray(event.resource) &&
        event.resource.some((id) => exportResources.includes(Number(id)));

      if (!hasResource || !event.start) {
        return false;
      }

      //EVENT-START
      const start =
        event.start instanceof Date
          ? event.start
          : new Date(event.start as string);

      //EVENT GLEICH MIT SELECTED DATE?
      const sameDay =
        start.getFullYear() === selected.getFullYear() &&
        start.getMonth() === selected.getMonth() &&
        start.getDate() === selected.getDate();

      return sameDay;
    });

    const mappedExportHighlightedTimes = exportHighlightedTimes.map(
      (color) => ({
        ...color,
        cssClass: `${color.cssClass}-export`,
      }),
    );

    //OPTIONEN FÜR DATEI-NAME VORBEREITEN
    const date = new Date(this.selectedDate);
    const formattedDate = date.toLocaleDateString('de-DE').replace(/\./g, '.');
    const weekday = date.toLocaleDateString('de-DE', {
      weekday: 'long',
    });

    const teamName = team.name;

    const teamFileId = this.getTeamFileId(teamName);

    //EVENTS, COLORS UND RESOURCEN FÜR EXPORT KALENDER SETZEN
    this.exportEvents = exportEvents;
    this.exportResources = [team];
    this.exportColors = mappedExportHighlightedTimes;

    // Höhe anhand der tatsächlichen Ressourcen berechnen
    const resourceCount = team.children?.length ?? 0;
    const resourceRowHeight = 101;
    const headerHeight = 120;

    const exportHeight = headerHeight + resourceCount * resourceRowHeight;

    this.exportCalendarOptions = {
      ...this.calendarOptions,
      height: exportHeight,
    };

    //ERSTELLEN
    this.createScreenshot(formattedDate, weekday, teamFileId);
  }

  getTeamFileId(teamName: String) {
    switch (teamName) {
      case 'Team Türkis':
        return '1';
      case 'Team Orange':
        return '2';
      case 'Team Blau':
        return '3';
      case 'Team Grün':
        return '4';
      default:
        return '';
    }
  }

  minutesHidden = false;

  toggleMinutesVisibility(): void {
    console.log('Sdfgsdf');
    this.minutesHidden = !this.minutesHidden;
  }

  async createScreenshot(
    formattedDate: string,
    weekday: string,
    teamFileId: string,
  ): Promise<void> {
    let clone: HTMLElement | null = null;

    try {
      // Mobiscroll vollständig rendern lassen
      await new Promise<void>((resolve) => setTimeout(resolve, 1000));

      const schedulerElement = this.exportCalendar.nativeElement as HTMLElement;

      const exportContainer =
        (schedulerElement.closest(
          '.export-calendar-container',
        ) as HTMLElement | null) ?? schedulerElement;

      const originalScroll = exportContainer.querySelector<HTMLElement>(
        '.mbsc-timeline-grid-scroll',
      );

      const originalGrid = exportContainer.querySelector<HTMLElement>(
        '.mbsc-timeline-grid',
      );

      const originalResourceList = exportContainer.querySelector<HTMLElement>(
        '.mbsc-timeline-resource-col.mbsc-timeline-resources',
      );

      if (!originalScroll || !originalGrid || !originalResourceList) {
        throw new Error(
          'Timeline-Scrollbereich, Zeitraster oder Ressourcenliste wurde nicht gefunden.',
        );
      }

      const fullHeight = Math.max(
        originalScroll.scrollHeight,
        originalGrid.scrollHeight,
        originalResourceList.scrollHeight,
      );

      // Temporäre Kopie erstellen
      clone = exportContainer.cloneNode(true) as HTMLElement;

      Object.assign(clone.style, {
        position: 'fixed',
        left: '0',
        top: '0',
        width: `${exportContainer.getBoundingClientRect().width}px`,
        height: 'auto',
        minHeight: '0',
        maxHeight: 'none',
        overflow: 'visible',
        opacity: '1',
        pointerEvents: 'none',
        zIndex: '999999',
        background: '#ffffff',
      });

      document.body.appendChild(clone);

      // Die drei entscheidenden Bereiche in der Kopie suchen
      const scrollElement = clone.querySelector<HTMLElement>(
        '.mbsc-timeline-grid-scroll',
      );

      const gridElement = clone.querySelector<HTMLElement>(
        '.mbsc-timeline-grid',
      );

      const resourceList = clone.querySelector<HTMLElement>(
        '.mbsc-timeline-resource-col.mbsc-timeline-resources',
      );

      if (!scrollElement || !gridElement || !resourceList) {
        throw new Error(
          'Timeline-Elemente in der Kopie wurden nicht vollständig gefunden.',
        );
      }

      // Scrollposition zurücksetzen
      scrollElement.scrollTop = 0;
      scrollElement.scrollLeft = 0;

      // Ressourcenliste, Zeitraster und Scrollbereich angleichen
      const timelineElements = [scrollElement, gridElement, resourceList];

      timelineElements.forEach((element) => {
        element.style.setProperty('height', `${fullHeight}px`, 'important');

        element.style.setProperty('min-height', `${fullHeight}px`, 'important');

        element.style.setProperty('max-height', 'none', 'important');
      });

      // Scrollbereich vollständig öffnen
      scrollElement.style.setProperty('overflow-y', 'visible', 'important');

      scrollElement.style.setProperty('overflow-x', 'visible', 'important');

      // Übergeordnete Container dürfen die Höhe nicht begrenzen
      let parent = scrollElement.parentElement;

      while (parent && parent !== clone) {
        parent.style.setProperty('max-height', 'none', 'important');

        parent.style.setProperty('overflow', 'visible', 'important');

        parent = parent.parentElement;
      }

      // Export-Container ausreichend groß machen
      clone.style.setProperty('height', 'auto', 'important');

      clone.style.setProperty(
        'min-height',
        `${fullHeight + 120}px`,
        'important',
      );

      clone.style.setProperty('max-height', 'none', 'important');

      clone.style.setProperty('overflow', 'visible', 'important');

      // Browser-Layout neu berechnen lassen
      await new Promise<void>((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(() => resolve())),
      );

      // Tatsächliche Screenshot-Größe bestimmen
      const screenshotWidth = Math.ceil(
        Math.max(clone.scrollWidth, clone.getBoundingClientRect().width),
      );

      const screenshotHeight = Math.ceil(
        Math.max(clone.scrollHeight, clone.getBoundingClientRect().height),
      );

      const canvas = await html2canvas(clone, {
        useCORS: true,
        allowTaint: false,
        logging: true,
        backgroundColor: '#ffffff',
        scale: 1,
        width: screenshotWidth,
        height: screenshotHeight,
        windowWidth: Math.max(window.innerWidth, screenshotWidth),
        windowHeight: Math.max(window.innerHeight, screenshotHeight),
        scrollX: 0,
        scrollY: 0,
      });

      // PNG speichern
      const link = document.createElement('a');

      link.download = `${formattedDate} ${weekday} ${teamFileId}.png`;

      link.href = canvas.toDataURL('image/png');

      document.body.appendChild(link);
      link.click();
      link.remove();

      this.toastService.successToast('Screenshot gespeichert');
    } catch (error) {
      console.error('Fehler beim Screenshot:', error);
    } finally {
      // Temporäre Kopie immer entfernen
      clone?.remove();

      this.isExporting = false;
    }
  }

  async filterMyEvents(event: any) {
    const eventId = String(event.id || '');
    const baseId = eventId.split('-')[0];
    const refId = Number(event.refId || baseId);

    const matchingEvents = this.myEvents.filter((e: any) => {
      const eId = String(e.id || '');
      const eBaseId = eId.split('-')[0];
      const eRefId = Number(e.refId || eBaseId);

      return eRefId === refId || eBaseId === baseId;
    });

    if (matchingEvents.length > 0) {
      const allResources = matchingEvents
        .filter((e) => Array.isArray(e['eventResources']))
        .flatMap((e) => e['eventResources']);
      const uniqueResources = [...new Set(allResources)];

      return { matchingEvents, allResources: uniqueResources };
    } else {
      console.warn('Keine passenden Events gefunden für:', event.id);
      return { matchingEvents: [], allResources: [] };
    }
  }

  async loadOptions() {
    const options: any = await this.getOptionsService.fetchOptions();

    if (options && options.teams) {
      this.stammteamData = options.teams.map((t: any) => ({
        // text: t.name,
        // value: t.id,
        collapsed: t.collapsed,
        color: t.color,
        created_at: t.created_at,
        eventCreation: t.eventCreation,
        eventDragBetweenResources: t.eventDragBetweenResources,
        eventDragInTime: t.eventDragInTime,
        eventResize: t.eventResize,
        eventoverlap: t.eventoverlap,
        fixed: t.fixed,
        id: t.id,
        isParent: t.isParent,
        lastUpdated_at: t.lastUpdated_at,
        name: t.name,
      }));
    }
  }

  //Kunden vereinheitlichen
  private normalizeCustomer(c: any) {
    return {
      id: c.id,
      firstname: c.firstname ?? c.firstName,
      lastname: c.lastname ?? c.lastName,
      color: c.color,
      stammteam: c.stammteam,
    };
  }

  //Kunden erstellen vom Popup aus
  async createCustomer(newCustomer: any) {
    try {
      const response = await this.postCustomerService.postCustomer(newCustomer);
      let id = response.id;
      const all = (await this.getCustomerService.fetchCustomer()) as any;
      let allCustomers = all.customerNew;
      const newOne = await allCustomers.find((c: { id: any }) => c.id === id);
      const customer = this.normalizeCustomer(newOne);

      //Neuen Kunden an das Popup geben
      this.newlyCreatedCustomer = customer;
    } catch (err) {
      console.error('Fehler beim Anlegen des Kunden:', err);
    }
  }

  async onTravelTimeRequested(destination: string) {
    try {
      const data = await this.traveltimeService.getTraveltime(destination);
      this.travelTimeData = data;
    } catch (err) {
      console.error('Fehler beim Abrufen der Reisezeit:', err);
      this.travelTimeData = { duration: 0, error: true };
    }
  }

  //FARHTZEITBERECHNUNG FÜR DAS EVENT-POPUP
  async getTravelTimeWithGoogle(destination: string) {
    try {
      const data = await this.traveltimeService.getTraveltime(destination);

      this.travelTimeData = data;
    } catch {
      this.travelTimeData = {
        duration: 0,
        error: true,
      };
    }
  }

  //async getTravelTimeWithGoogle(destination: string) {
  //  try {
  //    const data = await this.traveltimeService.getTraveltime(destination);
  //
  //    if (data) {
  //      const duration = data.duration;
  //      this.travelTimeData = {
  //        duration,
  //        destination: data.destination_addresses[0]
  //      };
  //
  //      this.toastService.successToast(`Berechnete Zeit: ${duration} Minuten`);
  //    } else {
  //      console.error('Keine gültige Distanz-/Zeitinfo erhalten:', data);
  //    }
  //
  //  } catch (error) {
  //    console.error('Fehler beim Abrufen der Reisezeit:', error);
  //    this.toastService.dangerToast('Fehler beim Abrufen der Reisezeit.');
  //  }
  //}

  public handleZoom(zoom: number): void {
    this.zoomLevel = Math.max(1, Math.min(zoom, 18));
    this.refDate = this.getRefDate(this.calendar.getViewDate());
  }

  public handleInput(ev: Event): void {
    this.handleZoom(+(ev.target as HTMLInputElement).value);
  }

  public getRefDate(viewDate: Date): Date {
    return new Date(viewDate.getFullYear(), viewDate.getMonth(), 1);
  }

  private formatTimeStampToDate(date: Date): string {
    // lokale Zeit verwenden
    const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().split('T')[0];
  }

  private handleKeydown = (event: KeyboardEvent) => {
    const safedkeyRaw = localStorage.getItem('closeColumnMarking');
    if (!safedkeyRaw) return;

    const safedkey = JSON.parse(safedkeyRaw);
    if (event.key === safedkey) {
      this.clearHighlightsOnClickOutside();
    }
  };

  async customerSearchFiltering(filterText: string) {
    const data = await this.getCustomerService.fetchCustomerSearch(filterText);

    const foundCustomers: any[] = [];
    if (data) {
      for (const customer of data) {
        const customerName = customer.firstname + ' ' + customer.lastname;
        foundCustomers.push({ text: customerName, value: customer.id });
      }
      this.customersData = data;
      this.filteredCustomers = foundCustomers;
    }

    return this.filteredCustomers;
  }

  onPageLoaded(ev: any) {
    if (!this.calendar?.nativeElement || this.scrollListenerAttached) {
      return;
    }
    const timelineEl = this.calendar.nativeElement.querySelector(
      '.mbsc-timeline-grid-scroll',
    );

    if (!timelineEl) {
      console.warn('Timeline element not found');
      return;
    }

    timelineEl.addEventListener('scroll', (ev: any) => {
      const scrollLeft = ev.target.scrollLeft;
      const hourWidth = this.getHourWidthByZoom(); // zoom1 = 120, zoom2 = 240, zoom3 = 480;
      const totalHours = scrollLeft / hourWidth;
      const hours = Math.floor(totalHours);
      const minutes = Math.floor((totalHours - hours) * 60);
      this.lastVisibleTime = { hours, minutes };
    });

    this.scrollListenerAttached = true;
  }

  getHourWidthByZoom() {
    switch (this.zoomLevel) {
      case (this.zoomLevel = 1):
        return 120;
      case (this.zoomLevel = 2):
        return 240;
      case (this.zoomLevel = 3):
        return 480;
      default:
        return 120;
    }
  }

  successToastNotification(message: any) {
    this.toastService.successToast(message);
  }

  async ngAfterViewInit() {
    this.inst = this.calendar._instanceService;

    this.route.queryParamMap.subscribe((params) => {
      const eventId = params.get('eventId');

      if (eventId) {
        this.getEventService.fetchEventWithId(eventId).subscribe((response) => {
          if (response?.length) {
            this.selectedEvent = response[0];
            this.onEventOpenWIthId(this.selectedEvent);
          }
        });
      }
    });
  }

  private initDate() {
    const dateParam = this.route.snapshot.paramMap.get('date');

    if (dateParam) {
      const date = new Date(dateParam);

      if (!isNaN(date.getTime())) {
        this.dateChangeService.setSelectedDate(date);
        return;
      }
    }

    const today = new Date();
    this.dateChangeService.setSelectedDate(today);

    this.router.navigate(
      ['/admin-calendar', today.toISOString().split('T')[0]],
      { replaceUrl: true },
    );
  }

  private subscribeToDate() {
    this.dateChangeService.selectedDate$
      .pipe(takeUntil(this.destroy$))
      .subscribe((date) => {
        if (!date) return;

        this.selectedDate = date;
        this.onDateChange(date);
      });
  }

  async ngOnInit() {
    this.isDarkMode = this.themeService.isDarkMode;
    this.initDate();
    this.subscribeToDate();

    // Event-Klick Subscription
    this.subscriptions.add(
      this.calendarEventService.eventClicked$.subscribe((args) => {
        this.onEventClicked(args);
      }),
    );

    // Tastatur-Event
    document.addEventListener('keydown', this.handleKeydown);

    // Socket-Verbindungen
    // this.socketService.connect();
    await this.loadOptions();
    this.socketOnNewEvent();
    this.socketOnUpdateEvent();
    this.socketOnDeleteEvent();
    this.socketOnNewInvalid();
    this.socketOnDeleteInvalid();
    this.socketUpdateResources();

    //this.fetchInterpreters();

    // Berechtigungen prüfen
    this.permissionService.checkPermission();

    // Events regelmäßig neu laden (alle 5 Minuten)
    this.refreshInterval = setInterval(() => {
      this.fetchEventsInPresentedPeriod();
    }, 300_000);

    // ✅ Nur hier initialisieren (asynchron, nach erstem CD-Zyklus)
    Promise.resolve().then(() => {
      this.startOfDay.setHours(0, 0, 0, 0);
      this.endOfDay.setHours(23, 59, 59, 999);
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    document.removeEventListener('keydown', this.handleKeydown);
    this.destroy$.next();
    this.destroy$.complete();
  }

  async fetchEventsInPresentedPeriod() {
    try {
      await this.fetchEvents(this.startOfDay, this.endOfDay);
      // await this.fetchEventsWithErrors(this.startOfDay);
      await this.fetchBlocker(this.startOfDay, this.endOfDay);
      await this.fetchPrivateEvents(this.startOfDay);
    } catch (error) {
      console.error('Fehler beim periodischen Laden:', error);
    }
  }

  async socketOnNewEvent() {
    this.socketService.onNewEvent().subscribe(async (event) => {
      console.log('New websocket event:', event);
      const myId = this.getUserId();
      if (myId === event.event.authorId) {
        return;
      }
      this.processNewEvent(event, 'websocket');
    });
  }

  async processNewEvent(event: any, method: string) {
    if (method === 'local') {
      event = event;
    } else {
      event = event.event;
    }

    // =========================
    // BUILD MAIN EVENT
    // =========================
    const mobiscrollEvent: MbscCalendarEvent = {
      id: event.id,
      isTemplate: event.isTemplate,
      title: event.title,
      start: new Date(event.start),
      end: new Date(event.end),
      location: event.location,
      color: this.colorService.getStatusColor(event),
      description: event.description,
      cost: event.cost,
      status: event.status,
      category: event.category,
      resource: event.resource,
      type: event.type,
      customer: event.customer,
      createdAt: event.created_at,
      bestaetigungsform: event.bestaetigungsform,
      blocker: event.blocker,
      blockerRef: event.blockerRef,
      bufferAfter: event.bufferAfter,
      bufferBefore: event.bufferBefore,
      calculateTraveltime: event.calculateTraveltime,
      deleted: event.deleted,
      dolmetscher: event.dolmetscher,
      einsatzzeit: event.einsatzzeit,
      offeneTermine: event.offeneTermine,
      online: event.online,
      onlineLink: event.onlineLink,
      recurringids: event.recurringids,
      ticketno: event.ticketno,
      traveltime: event.traveltime,
      vorbereitungsmaterial: event.vorbereitungsmaterial,
      vorbereitungsmaterialLink: event.vorbereitungsmaterialLink,
      recurring: event.recurring,
      recurringException: event.recurringException,
      dialinTime: event.dialinTime,
      minuteBased: event.minuteBased,
      subtypes: event.subtypes,
      informations: event.informations,
      traveltimeBefore: event.traveltimeBefore,
      traveltimeAfter: event.traveltimeAfter,
      aufzeichnung: event.aufzeichnung,
      vorbereitung: event.vorbereitung,
      vorbereitungZeit: event.vorbereitungZeit,
      abrechnungArt: event.abrechnungArt,
      fremdCoAbrechnung: event.fremdCoAbrechnung,
      resourceMeta: event.resourceMeta,
    };

    // =========================
    // CLEAN RECURRING
    // =========================
    if (event.recurring) {
      const cleanedObj = await this.cleanRecurring(event);
      if (!this.isEmptyObject(cleanedObj)) {
        mobiscrollEvent.recurring = cleanedObj;
      } else {
        delete mobiscrollEvent.recurring;
      }
    }

    // =========================
    // PARSE JSON FIELDS
    // =========================
    if (mobiscrollEvent['onlineLink']) {
      mobiscrollEvent['onlineLink'] = JSON.parse(event.onlineLink);
    }
    if (mobiscrollEvent['informations']) {
      mobiscrollEvent['informations'] = JSON.parse(event.informations);
    }

    //SKILL-SERVICE
    mobiscrollEvent['skillWarn'] =
      this.skillService.checkSkillsAndKundenteam(mobiscrollEvent);

    const newEvent = mobiscrollEvent;

    //CHECK OB EVENT ALS COLOR DARGESTELLT WERDEN SOLL
    const eventAsColor = this.checkEventAsColor(mobiscrollEvent);

    //WENN COLOR DANN HIER ABBRECHEN
    if (eventAsColor) {
      return;
    }

    // =========================
    // STATE UPDATE (IMMER!)
    // =========================

    //this.myEvents = [...this.myEvents, newEvent];

    //this.myEventsCopy = [...this.myEvents];

    // =========================
    // CALENDAR UPDATE
    // =========================

    //this.inst?.instance
    //  ? this.inst.instance.addEvent(newEvent)
    //  : this.inst.addEvent(newEvent);
    //
    //this.appendResttime(this.myEvents, this.startOfDay);

    // =========================
    // TEMP EVENTS (NUR UI)
    // =========================
    const needsTempEvents =
      Array.isArray(event.resource) &&
      (event.resource.length > 1 ||
        event.resource.length < Number(event.dolmetscher));
    if (needsTempEvents) {
      // Nur TempEvents erstellen
      const tempEvents = await this.createTempEvent(event, this.myEvents);

      // Nur TempEvents ins State übernehmen
      this.myEvents = [...this.myEvents, ...tempEvents];
    } else {
      // Normales Event
      this.myEvents = [...this.myEvents, newEvent];

      // Nur normales Event zu Mobiscroll
      this.inst?.instance
        ? this.inst.instance.addEvent(newEvent)
        : this.inst.addEvent(newEvent);
    }

    this.appendResttime(this.myEvents, this.startOfDay);

    this.updateEvents('main-first', newEvent);

    // =========================
    // SIDEBAR TASK BUILD (NUR AUS newEvent)
    // =========================
    if (!(newEvent.start instanceof Date) || !(newEvent.end instanceof Date)) {
      console.warn('Invalid date', newEvent);
      return;
    }
    const eventStart = newEvent.start;
    const eventEnd = newEvent.end;
    const isInCurrentDay =
      eventStart <= this.endOfDay && eventEnd >= this.startOfDay;

    if (!isInCurrentDay || newEvent['isTemplate'] !== 0) return;
    const dolmetscherCount = Number(newEvent['dolmetscher']) || 0;
    let resourceCount = 0;
    let hasNullResource = false;

    if (Array.isArray(newEvent.resource)) {
      const validResources = newEvent.resource.filter((r) => {
        if (r === null) hasNullResource = true;
        return r != null;
      });
      resourceCount = validResources.length;
    } else if (newEvent.resource) {
      resourceCount = 1;
    }

    let fremdDolmetscherCount = 0;
    let infoArray: any[] = [];

    if (Array.isArray(newEvent['informations'])) {
      infoArray = newEvent['informations'];
    }

    infoArray.forEach((info: any) => {
      const title = (info.title || '').toLowerCase();
      if (
        (title.includes('fremd') && title.includes('dolmetscher')) ||
        title.includes('fremd-co')
      ) {
        if (info.checked) {
          fremdDolmetscherCount += info.options?.length || 1;
        }
      }
    });

    const totalAssigned = resourceCount + fremdDolmetscherCount;
    const fehlendeDolmetscher = Math.max(0, dolmetscherCount - totalAssigned);
    const shouldGoToBacklog =
      hasNullResource || resourceCount === 0 || fehlendeDolmetscher > 0;

    if (!shouldGoToBacklog) return;

    const duration = (eventEnd.getTime() - eventStart.getTime()) / 60000;
    const task = {
      ...newEvent,
      resourceCount,
      fremdDolmetscherCount,
      totalAssigned,
      fehlendeDolmetscher,
      hasNullResource,
      length: `${(duration / 60).toFixed(1)} Std.`,
    };

    // =========================
    // MERGE TASK
    // =========================
    const idx = this.tasks.findIndex((t: any) => t.id === task.id);
    if (idx !== -1) {
      this.tasks[idx] = task;
    } else {
      this.tasks.push(task);
    }

    // =========================
    // SORT
    // =========================
    this.filteredTasks = [...this.tasks].sort(
      (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
    );

    const updatedResources =
      this.calcTraveltimeService.getTraveltimesForResources(
        this.myEvents,
        this.filterResourcesService.filteredResources,
        this.dateChangeService.selectedDateSource.value,
      );

    this.filterResourcesService.filteredResources = updatedResources.map(
      (team: any) => ({
        ...team,
        children: Array.isArray(team.children)
          ? team.children.map((resource: any) => ({ ...resource }))
          : [],
      }),
    );
  }

  async socketOnUpdateEvent() {
    this.socketService.onUpdateEvent().subscribe(async (event) => {
      const rawEvent = event.event;
      const pendingTime = this.pendingUpdates.get(rawEvent.id);

      if (pendingTime) {
        return;
      }
      this.processUpdatedEvent(rawEvent, 'websocket');
    });
  }

  onPendingUpdate(data: { id: string | number; time: number }) {
    this.pendingUpdates.set(data.id, data.time);
  }

  async processUpdatedEvent(eventUpdate: any, method: string) {
    const clonedEvent = structuredClone(eventUpdate);

    //clonedEvent.id = parseInt(clonedEvent.id);

    // falls recurring → bereinigen
    if (clonedEvent.recurring) {
      const cleanedObj = await this.cleanRecurring(clonedEvent);
      if (!this.isEmptyObject(cleanedObj)) {
        clonedEvent.recurring = cleanedObj;
      } else {
        delete clonedEvent.recurring;
      }
    }

    //Online Links Check
    let platforms = [];

    platforms = this.normalizeOnlineLink(clonedEvent.onlineLink);

    // Resource-Check
    const hasValidResource =
      Array.isArray(clonedEvent.resource) && clonedEvent.resource.length > 0;

    if (!hasValidResource) {
      this.updateEvents('main-first', clonedEvent);
      // wenn keine Resource → Event entfernen
      this.myEvents = this.myEvents.filter(
        (e) => e.id !== clonedEvent.id && e['refId'] !== clonedEvent.id,
      );
    } else {
      if (clonedEvent.resource.length === 1) {
        // alte Event Kopien entfernen
        this.myEvents = this.myEvents.filter(
          (e) => e.id !== clonedEvent.id && e['refId'] !== clonedEvent.id,
        );
      }

      // Alte Color-Einträge entfernen
      this.highlightedTimes = this.highlightedTimes.filter(
        (h) => h.id !== clonedEvent.id,
      );

      let resourceMeta = clonedEvent.resourceMeta;

      if (typeof resourceMeta === 'string') {
        resourceMeta = JSON.parse(resourceMeta || '[]');
      }

      const resourceStatus = Array.isArray(resourceMeta)
        ? resourceMeta.find(
            (meta: any) => Number(meta.id) === Number(clonedEvent.resource[0]),
          )?.status
        : undefined;

      const mobiscrollEvent: MbscCalendarEvent = {
        id: clonedEvent.id,
        isTemplate: clonedEvent.isTemplate,
        title: clonedEvent.title,
        start: new Date(clonedEvent.start),
        end: new Date(clonedEvent.end),
        location: clonedEvent.location,
        color: this.colorService.getStatusColor(clonedEvent),
        description: clonedEvent.description,
        cost: clonedEvent.cost,
        //status: clonedEvent.status,
        status: resourceStatus,
        category: clonedEvent.category,
        resource: clonedEvent.resource,
        type: clonedEvent.type,
        customer: clonedEvent.customer,
        createdAt: clonedEvent.created_at,
        bestaetigungsform: clonedEvent.bestaetigungsform,
        blocker: clonedEvent.blocker,
        blockerRef: clonedEvent.blockerRef,
        bufferAfter: clonedEvent.bufferAfter,
        bufferBefore: clonedEvent.bufferBefore,
        calculateTraveltime: clonedEvent.calculateTraveltime,
        deleted: clonedEvent.deleted,
        dolmetscher: clonedEvent.dolmetscher,
        einsatzzeit: clonedEvent.einsatzzeit,
        offeneTermine: clonedEvent.offeneTermine,
        online: clonedEvent.online,
        onlineLink: platforms,
        recurringids: clonedEvent.recurringids,
        ticketno: clonedEvent.ticketno,
        traveltime: clonedEvent.traveltime,
        vorbereitungsmaterial: clonedEvent.vorbereitungsmaterial,
        vorbereitungsmaterialLink: clonedEvent.vorbereitungsmaterialLink,
        recurring: clonedEvent.recurring,
        recurringException: clonedEvent.recurringException,
        dialinTime: clonedEvent.dialinTime,
        minuteBased: clonedEvent.minuteBased,
        subtypes: clonedEvent.subtypes,
        eventResources: clonedEvent.eventResources,
        informations: clonedEvent.informations,
        traveltimeBefore: clonedEvent.traveltimeBefore,
        traveltimeAfter: clonedEvent.traveltimeAfter,
        aufzeichnung: clonedEvent.aufzeichnung,
        vorbereitung: clonedEvent.vorbereitung,
        vorbereitungZeit: clonedEvent.vorbereitungZeit,
        abrechnungArt: clonedEvent.abrechnungArt,
        fremdCoAbrechnung: clonedEvent.fremdCoAbrechnung,
        ueberprueft: clonedEvent.ueberprueft,
        resourceMeta: clonedEvent.resourceMeta,
      };

      if (!mobiscrollEvent['calculateTraveltime']) {
        mobiscrollEvent['bufferBefore'] = clonedEvent.traveltimeBefore;
        mobiscrollEvent['bufferAfter'] = clonedEvent.traveltimeAfter;
      }

      if (mobiscrollEvent['onlineLink']) {
        mobiscrollEvent['onlineLink'] = JSON.parse(clonedEvent.onlineLink);
      }

      if (mobiscrollEvent['informations']) {
        mobiscrollEvent['informations'] = JSON.parse(clonedEvent.informations);
      }

      if (typeof mobiscrollEvent['resourceMeta'] === 'string') {
        mobiscrollEvent['resourceMeta'] = JSON.parse(clonedEvent.resourceMeta);
      } else {
        mobiscrollEvent['resourceMeta'] = clonedEvent.resourceMeta;
      }

      if (clonedEvent.resource.length > 1) {
        if (this.onlyMetaChange) {
          const tempEvents = await this.updateTempEventsResourceMeta(
            clonedEvent,
            this.myEvents,
          );
          this.myEvents = this.myEvents.filter(
            (e) => e.id !== clonedEvent.id && e['refId'] !== clonedEvent.id,
          );
          this.myEvents.push(...tempEvents);
        } else {
          // alte Event Kopien entfernen
          this.myEvents = this.myEvents.filter(
            (e) => e.id !== clonedEvent.id && e['refId'] !== clonedEvent.id,
          );
          const tempEvents = await this.createTempEventAfterUpdate(
            clonedEvent,
            this.myEvents,
          );
          this.myEvents.push(...tempEvents);
        }
      } else {
        //SKILL-SERVICE
        mobiscrollEvent['skillWarn'] =
          this.skillService.checkSkillsAndKundenteam(mobiscrollEvent);

        //CHECK OB EVENT ALS COLOR DARGESTELLT WERDEN SOLL
        const eventAsColor = this.checkEventAsColor(mobiscrollEvent);

        //WENN COLOR DANN HIER ABBRECHEN
        if (eventAsColor) {
          return;
        }

        this.myEvents.push(mobiscrollEvent);
      }

      if (!this.onlyMetaChange) {
        this.updateEvents('main-first', mobiscrollEvent);
      }

      //this.updateEvents('temp-first', mobiscrollEvent);
      setTimeout(() => {
        this.inst?.instance?.updateEvent?.(mobiscrollEvent);
      }, 0);

      //this.updateTempEvents(mobiscrollEvent);
    }

    // Private Events & Restzeit aktualisieren
    if (clonedEvent.type === 'PRIVATEEVENT') {
      this.fetchPrivateEvents(this.startOfDay);
    }

    //AUSKOMMENTIERT, WEIL DOPPELTER DIRECTIONS AUFRUF
    //this.fetchEvents(this.startOfDay, this.endOfDay)

    this.appendResttime(this.myEvents, this.startOfDay);

    // TEMP-Events aktualisieren
    this.myEvents = this.myEvents.map((e) => {
      if (e['refId'] === clonedEvent.id) {
        return {
          ...e,
          status: clonedEvent.status,
          color: this.colorService.getStatusColor(clonedEvent),
          description: clonedEvent.description,
        };
      }
      return e;
    });

    const updatedResources =
      this.calcTraveltimeService.getTraveltimesForResources(
        this.myEvents,
        this.filterResourcesService.filteredResources,
        this.dateChangeService.selectedDateSource.value,
      );

    this.filterResourcesService.filteredResources = updatedResources.map(
      (team: any) => ({
        ...team,
        children: Array.isArray(team.children)
          ? team.children.map((resource: any) => ({ ...resource }))
          : [],
      }),
    );
    //this.myEventsCopy = [...this.myEvents];
    this.cdr.detectChanges();

    //BACKLOG EVENTS
    // Index im Array
    // ✅ Nur Events des aktuell angezeigten Tages berücksichtigen
    const eventStart = new Date(clonedEvent.start);
    const eventEnd = new Date(clonedEvent.end);
    const isInCurrentDay =
      eventStart <= this.endOfDay && eventEnd >= this.startOfDay;

    // ❌ Wenn Event NICHT im aktuellen Tag liegt → aus Sidebar entfernen & abbrechen
    if (!isInCurrentDay) {
      this.tasks = this.tasks.filter((t: any) => t.id !== clonedEvent.id);
      this.filteredTasks = [...this.tasks].sort(
        (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
      );
      return;
    }

    let idx = this.tasks.findIndex((e: { id: any }) => e.id === clonedEvent.id);

    const taskToUpdate = { ...clonedEvent };

    // Counters berechnen
    const dolmetscherCount = Number(clonedEvent.dolmetscher) || 0;
    let resourceCount = 0;
    let hasNullResource = false;
    if (Array.isArray(clonedEvent.resource)) {
      const validResources = clonedEvent.resource.filter((r: any) => {
        if (r === null) hasNullResource = true;
        return r != null;
      });
      resourceCount = validResources.length;
    } else if (
      typeof clonedEvent.resource === 'number' ||
      typeof clonedEvent.resource === 'string'
    ) {
      resourceCount = 1;
    }

    let fremdDolmetscherCount = 0;
    let infoArray: any[] = [];

    if (
      typeof clonedEvent.informations === 'string' &&
      clonedEvent.informations.trim() !== ''
    ) {
      try {
        infoArray = JSON.parse(clonedEvent.informations);
      } catch {
        infoArray = [];
      }
    } else if (Array.isArray(clonedEvent.informations)) {
      infoArray = clonedEvent.informations;
    }

    if (Array.isArray(infoArray)) {
      infoArray.forEach((info: any) => {
        const title = (info.title || info.icon_name || '').toLowerCase();
        if (
          (title.includes('fremd') && title.includes('dolmetscher')) ||
          title.includes('fremd-co') ||
          title.includes('fremddolmetscher')
        ) {
          if (info.checked) {
            fremdDolmetscherCount +=
              Array.isArray(info.options) && info.options.length > 0
                ? info.options.length
                : 1;
          }
        }
      });
    }

    const totalAssigned = resourceCount + fremdDolmetscherCount;
    const fehlendeDolmetscher = Math.max(0, dolmetscherCount - totalAssigned);

    // Counters setzen
    taskToUpdate.resourceCount = resourceCount;
    taskToUpdate.fremdDolmetscherCount = fremdDolmetscherCount;
    taskToUpdate.totalAssigned = totalAssigned;
    taskToUpdate.fehlendeDolmetscher = fehlendeDolmetscher;
    taskToUpdate.hasNullResource = hasNullResource;

    // Länge berechnen
    const startDate = new Date(clonedEvent.start);
    const endDate = new Date(clonedEvent.end);
    const durationInMinutes = (endDate.getTime() - startDate.getTime()) / 60000;
    taskToUpdate.length = `${(durationInMinutes / 60).toFixed(1)} Std.`;

    // ✅ Event hinzufügen, aktualisieren oder löschen
    if (fehlendeDolmetscher === 0) {
      // Wenn vorhanden → löschen
      if (idx !== -1) this.tasks.splice(idx, 1);
    } else {
      if (idx !== -1) {
        // Event existiert → updaten
        this.tasks[idx] = taskToUpdate;
      } else {
        // Event existiert nicht → hinzufügen
        this.tasks.push(taskToUpdate);
      }
    }

    // filteredTasks aktualisieren und sortieren
    this.filteredTasks = [...this.tasks].sort(
      (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime(),
    );
    this.onlyMetaChange = false;
  }

  async socketOnDeleteEvent() {
    this.socketService.onDeleteEvent().subscribe(async (event) => {
      const id = event.event;

      const eventToDelete = this.myEvents.find((e) => e.id === id);
      let previousEvent;
      let nextEvent;
      // this.updateEvents('main-first',eventToDelete);
      if (eventToDelete && eventToDelete['type'] === 'MISSIONEVENT') {
        previousEvent = this.findPreviousEvent(eventToDelete);
        nextEvent = this.findNextEvent(eventToDelete);
      }

      //if(typeof id === "string"){

      //  // Event aus myEvents entfernen
      //  this.myEvents = this.myEvents.filter(e => {
      //    // e.id kann string oder number sein
      //    return e.id !== id;
      //  });

      //}else{
      const numericId = Number(event.event);

      this.highlightedTimes = this.highlightedTimes.filter(
        (color) => color.id !== numericId,
      );

      // Event aus Mobiscroll entfernen
      setTimeout(() => {
        this.inst?.instance?.removeEvent(numericId);
      }, 0);

      // Event aus myEvents entfernen
      this.myEvents = this.myEvents.filter((e) => {
        // e.id kann string oder number sein
        return Number(e.id) !== numericId;
      });

      //TempEvents löschen wenn vorhanden
      this.deleteTempEvents(numericId);

      //Backlog Termine löschen wenn vorhanden
      this.deleteBacklogEvents(numericId);
      // }

      // Buffer der beiden Nachbarn neu berechnen
      if (previousEvent) {
        await this.refreshBuffer(previousEvent);
      }

      if (nextEvent) {
        await this.refreshBuffer(nextEvent);
      }

      //this.myEvents = [...this.myEvents];

      //Ruhezeiten neu setzen
      this.appendResttime(this.myEvents, this.startOfDay);

      // Angular Change Detection triggern
      this.cdr.detectChanges();
    });
  }

  // Aktualisiert ausschließlich resourceMeta vorhandener TempEvents
  async updateTempEventsResourceMeta(event: any, events: any[]) {
    const refId = event.id;

    // resourceMeta aus dem aktualisierten Hauptevent übernehmen
    let resourceMeta;

    if (typeof event.resourceMeta === 'string') {
      resourceMeta = JSON.parse(event.resourceMeta);
    } else {
      resourceMeta = event.resourceMeta;
    }

    // Vorhandene TempEvents mit passender refId aktualisieren
    const updatedEvents = events
      .filter(
        (existingEvent: any) =>
          existingEvent.isTempEvent === true &&
          String(existingEvent.refId) === String(refId),
      )
      .map((existingEvent: any) => ({
        ...existingEvent,
        resourceMeta: resourceMeta,
      }));

    // Änderungen in events übernehmen
    updatedEvents.forEach((updatedEvent: any) => {
      const index = events.findIndex(
        (existingEvent: any) => existingEvent.id === updatedEvent.id,
      );

      if (index !== -1) {
        events[index] = updatedEvent;
      }
    });

    return updatedEvents;
  }

  async refreshBuffer(event: any) {
    const currentStart = new Date(event.start);
    const currentDate = currentStart.toISOString().split('T')[0];

    const rawResource = Array.isArray(event.resource)
      ? event.resource[0]
      : event.resource;

    const resource = rawResource !== undefined ? Number(rawResource) : null;

    if (resource === null || Number.isNaN(resource)) return;

    const bufferBeforeObj = await this.bufferService.getBufferBefore(
      event,
      this.myEvents,
      resource,
      currentStart,
      currentDate,
    );

    const bufferAfterObj = await this.bufferService.getBufferAfter(
      event,
      this.myEvents,
      resource,
      currentStart,
      currentDate,
    );

    event['previousEventLocation'] = bufferBeforeObj.previousEventLocation;
    event['earlierEvent'] = bufferBeforeObj.earlierEvent;
    event.bufferBefore = bufferBeforeObj.bufferBefore || 0;

    event['nextEventLocation'] = bufferAfterObj.nextEventLocation;
    event['nextEvent'] = bufferAfterObj.nextEvent;
    event.bufferAfter = bufferAfterObj.bufferAfter || 0;
  }

  getResources(event: any): number[] {
    return Array.isArray(event.resource) ? event.resource : [event.resource];
  }

  findPreviousEvent(eventToDelete: any) {
    const previousEvents = this.myEvents.filter((existing: any) => {
      let sameResource;
      let currentStart;
      const resources = this.getResources(eventToDelete);

      if (!Array.isArray(existing.resource)) {
        if (existing.resource === resources) {
          sameResource = existing.resource;
        }
      } else {
        sameResource = existing.resource.some((r: any) =>
          resources.includes(r),
        );
      }

      currentStart = new Date(eventToDelete.start);
      const currentDate = currentStart.toISOString().split('T')[0];
      const existingStart = new Date(existing.start);
      const existingDate = existingStart.toISOString().split('T')[0];
      const isSameDay = existingDate === currentDate;
      const isEarlier = existingStart < currentStart;

      return sameResource && isSameDay && isEarlier;
    });

    const previousEvent = previousEvents.sort((a, b) => {
      return (
        new Date(b.start as any).getTime() - new Date(a.start as any).getTime()
      );
    })[0];

    return previousEvent;
  }

  findNextEvent(eventToDelete: any) {
    const nextEvents = this.myEvents.filter((existing: any) => {
      let sameResource;
      let currentStart;
      const resources = this.getResources(eventToDelete);
      if (!Array.isArray(existing.resource)) {
        if (existing.resource === resources) {
          sameResource = existing.resource;
        }
      } else {
        sameResource = existing.resource.some((r: any) =>
          resources.includes(r),
        );
      }

      currentStart = new Date(eventToDelete.start);
      const currentDate = currentStart.toISOString().split('T')[0];
      const existingStart = new Date(existing.start);
      const existingDate = existingStart.toISOString().split('T')[0];
      const isSameDay = existingDate === currentDate;
      const isAfter = existingStart > currentStart;
      return sameResource && isSameDay && isAfter;
    });

    const nextEvent = nextEvents.sort(
      (a, b) =>
        new Date(a.start as any).getTime() - new Date(b.start as any).getTime(),
    )[0];

    return nextEvent;
  }

  async socketOnNewInvalid() {
    this.socketService.onNewInvalid().subscribe(async (invalid) => {
      console.log('New websocket Invalid:', invalid);
      let newInvalid = invalid.event;

      if (this.permissionService.userPermission === 'admin') {
        //Blocker (Colors) für Admins
        newInvalid = {
          id: newInvalid.id,
          text: newInvalid.title,
          start: newInvalid.start,
          end: newInvalid.end,
          cssClass: 'blocker-bg-calender-admin',
          resource: newInvalid.resources,
          type: 'Blocker',
        };

        this.highlightedTimes = [...this.highlightedTimes, newInvalid];
        this.updateCalendarOptions();
      } else {
        //Blocker für User
        newInvalid = {
          id: newInvalid.id,
          title: newInvalid.title,
          start: newInvalid.start,
          end: newInvalid.end,
          type: newInvalid.type,
          blocker: newInvalid.blocker,
          blockerRef: newInvalid.blockerRef,
          deleted: newInvalid.deleted,
          recurringids: newInvalid.recurringids,
          cssClass: newInvalid.cssClass,
          resource: newInvalid.resources,
        };

        // Beides kombinieren
        this.invalids = [...this.invalids, newInvalid];
        this.updateCalendarOptions();
      }
    });
  }

  async socketOnDeleteInvalid() {
    this.socketService.onDeleteInvalid().subscribe(async (invalid) => {
      console.log('Deleted websocket Invalid:', invalid);
      let deletedInvalid = Number(invalid.event);

      if (this.permissionService.userPermission === 'admin') {
        //Blocker (Colors) für Admins
        //Gelöschten Blocker aus den colors entfernen
        this.highlightedTimes = this.highlightedTimes.filter(
          (color) => color.id !== deletedInvalid,
        );
        this.updateCalendarOptions();
      } else {
        //Blocker für User
        //Gelöschten Blocker aus den invalids entfernen
        this.invalids = this.invalids.filter(
          (invalide) => invalide.id !== deletedInvalid,
        );
        this.invalids = [...this.invalids];
        this.updateCalendarOptions();
      }
    });
  }

  onResourceRender(e: any) {
    const resource = e.resource;

    // Nur Parent-Ressourcen (Teams)
    if (!resource.isParent) {
      return;
    }

    const prev = this.lastCollapsedState[resource.id];
    const current = resource.collapsed;

    // Nur reagieren, wenn sich der Zustand geändert hat
    if (prev !== undefined && prev !== current) {
      if (current) {
        console.log('Team eingeklappt:', resource.name);
      } else {
        console.log('Team ausgeklappt:', resource.name);
      }
    }

    // Zustand speichern
    this.lastCollapsedState[resource.id] = current;
  }

  async socketUpdateResources() {
    this.socketService.onResourceUpdate().subscribe(async (event) => {
      const users = event.resources;
      const Interpreter: Resource[] = users.map((user: any) => ({
        id: user.id,
        cr: user.abbreviation,
        name: `${user.firstName.trim()} ${user.lastName}`,
        color: user.color,
        background: this.colorService.lightenColor(user.color, 90),
        img: user.img,
        workingHours: user.workingHours,
        workingType: user.workingType,
        team: user.team,
        HOLIDAYEVENT_dayCount: user.HOLIDAYEVENT_dayCount,
        HOLIDAYEVENT_minutes: user.HOLIDAYEVENT_minutes,
        MEETINGEVENT_minutes: user.MEETINGEVENT_minutes,
        MISSIONEVENT_minutes: user.MISSIONEVENT_minutes,
        SICKEVENT_dayCount: user.SICKEVENT_dayCount,
        SICKEVENT_minutes: user.SICKEVENT_minutes,
        TOTAL_minutes: user.TOTAL_minutes,
        TOTAL_minutes_day: user.TOTAL_minutes_day,
        ueberstunden: user.ueberstunden,
        o365Id: user.o365Id,
      }));

      if (this.myResources) {
        //this.myResources = [...Interpreter];
        //await this.sortInterpreters();
        this.applyCollapsedTeams();
        this.filterResourcesService.filteredResources =
          this.updateInterpreters(Interpreter);
        this.cdr.detectChanges();
      }
    });
  }

  updateInterpreters(updatedUsers: any[]) {
    const groups = this.filterResourcesService.filteredResources;

    const map = new Map<string, any>();

    groups.forEach((group) => {
      group.children?.forEach((child) => {
        map.set(String(child.id), child);
      });
    });

    updatedUsers.forEach((user) => {
      const existing = map.get(String(user.id));

      if (existing) {
        Object.assign(existing, user);
      }
    });

    //neue Referenz
    this.filterResourcesService.filteredResources = [...groups];

    return groups;
  }

  applyCollapsedTeams() {
    if (!this.mySortedResources || this.mySortedResources.length === 0) return;

    const collapsedTeams: string[] = JSON.parse(
      localStorage.getItem('collapsedTeams') || '[]',
    );

    this.mySortedResources = this.mySortedResources.map((group) => ({
      ...group,
      collapsed: collapsedTeams.includes(group.id),
    }));

    this.filterResourcesService.filteredResources = this.mySortedResources;
  }

  deleteTempEvents(mainEventID: number) {
    if (!Array.isArray(this.myEvents)) {
      return;
    }
    this.myEvents = this.myEvents.filter(
      (event) => event?.['refId'] !== mainEventID,
    );
  }

  deleteBacklogEvents(mainEventID: number) {
    this.filteredTasks = this.filteredTasks.filter(
      (task: { id: number }) => task?.['id'] !== mainEventID,
    );
  }

  async updateEvents(order: 'main-first' | 'temp-first', mobiscrollEvent: any) {
    if (order === 'main-first') {
      await this.updateMainEventsBuffer(mobiscrollEvent);
      await this.updateTempEvents(mobiscrollEvent);
    } else {
      await this.updateTempEvents(mobiscrollEvent);
      await this.updateMainEventsBuffer(mobiscrollEvent);
    }
  }

  async updateMainEventsBuffer(updatedEvent: any) {
    if (this.newResource === undefined) {
      this.newResource = updatedEvent.resource;
    }

    if (this.originalEventData === undefined) return;

    if (this.oldResource === undefined) {
      this.oldResource = this.originalEventData.resource;
    }

    const updatedResource = this.newResource;
    const oldResource = this.oldResource;

    // ======================================================
    // HILFSFUNKTIONEN
    // ======================================================

    const getResourceIds = (resource: any): number[] => {
      const resources = Array.isArray(resource) ? resource : [resource];

      return resources
        .filter((id): id is string | number => id !== undefined && id !== null)
        .map((id) => Number(id))
        .filter((id) => !Number.isNaN(id));
    };

    const hasMatchingResource = (
      eventResource: any,
      resource: any,
    ): boolean => {
      const eventResources = getResourceIds(eventResource);
      const resourceIds = getResourceIds(resource);

      return eventResources.some((id) => resourceIds.includes(id));
    };

    const isSameDay = (date1: Date, date2: Date): boolean => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };

    // ======================================================
    // NEUE POSITION
    // ======================================================

    const updatedStartDate = this.normalizeToDate(updatedEvent.start);

    const updatedEndDate = this.normalizeToDate(updatedEvent.end);

    if (!updatedStartDate || !updatedEndDate) {
      console.warn('Updated Event hat kein gültiges Start-/Enddatum');
      return;
    }

    const updatedStart = updatedStartDate.getTime();

    const updatedEnd = updatedEndDate.getTime();

    // ======================================================
    // ALTE POSITION
    // ======================================================

    const originalStart = this.normalizeToDate(this.originalEventData?.start);

    const originalEnd = this.normalizeToDate(this.originalEventData?.end);

    if (!originalStart || !originalEnd) {
      console.warn('Original Event hat kein gültiges Start-/Enddatum');
    }

    const originalStartTs = originalStart?.getTime();

    const originalEndTs = originalEnd?.getTime();

    // ======================================================
    // RELEVANTE EVENTS
    // ======================================================

    const relevantEvents = this.myEvents.filter((event) => {
      if (event.id === updatedEvent.id) {
        return false;
      }

      if (!event['calculateTraveltime'] || event['isTempEvent']) {
        return false;
      }

      const startDate = this.normalizeToDate(event.start);

      const endDate = this.normalizeToDate(event.end);

      if (!startDate || !endDate) {
        return false;
      }

      event['_startTs'] = startDate.getTime();

      event['_endTs'] = endDate.getTime();

      return true;
    });

    // ======================================================
    // NEUE RESOURCE
    // ======================================================

    const newResourceEvents = relevantEvents.filter((event) =>
      hasMatchingResource(event.resource, updatedResource),
    );

    const previousNewEvent =
      newResourceEvents
        .filter((event) => {
          const eventDate = this.normalizeToDate(event.start);

          if (!eventDate) {
            return false;
          }

          return (
            isSameDay(eventDate, updatedStartDate) &&
            event['_endTs'] <= updatedStart
          );
        })
        .sort((a, b) => b['_endTs'] - a['_endTs'])[0] || null;

    const nextNewEvent =
      newResourceEvents
        .filter((event) => {
          const eventDate = this.normalizeToDate(event.start);

          if (!eventDate) {
            return false;
          }

          return (
            isSameDay(eventDate, updatedStartDate) &&
            event['_startTs'] >= updatedEnd
          );
        })
        .sort((a, b) => a['_startTs'] - b['_startTs'])[0] || null;

    // ======================================================
    // ALTE RESOURCE
    // ======================================================

    let previousOldEvent: any = null;
    let nextOldEvent: any = null;

    if (
      originalStart &&
      originalEnd &&
      originalStartTs !== undefined &&
      originalEndTs !== undefined
    ) {
      const oldResourceEvents = relevantEvents.filter((event) =>
        hasMatchingResource(event.resource, oldResource),
      );

      // ----------------------------------------------------
      // Direkt vorheriges Event ALTE RESOURCE
      // ----------------------------------------------------

      previousOldEvent =
        oldResourceEvents
          .filter((event) => {
            const eventDate = this.normalizeToDate(event.start);

            if (!eventDate) {
              return false;
            }

            return (
              isSameDay(eventDate, originalStart) &&
              event['_endTs'] <= originalStartTs
            );
          })
          .sort((a, b) => b['_endTs'] - a['_endTs'])[0] || null;

      // ----------------------------------------------------
      // Direkt nachfolgendes Event ALTE RESOURCE
      // ----------------------------------------------------

      nextOldEvent =
        oldResourceEvents
          .filter((event) => {
            const eventDate = this.normalizeToDate(event.start);

            if (!eventDate) {
              return false;
            }

            return (
              isSameDay(eventDate, originalStart) &&
              event['_startTs'] >= originalEndTs
            );
          })
          .sort((a, b) => a['_startTs'] - b['_startTs'])[0] || null;
    }

    // ======================================================
    // DEBUG
    // ======================================================

    //console.log(
    //  'ALTES - VORHER:',
    //  previousOldEvent
    //);

    //console.log(
    //  'ALTES - NACHHER:',
    //  nextOldEvent
    //);

    //console.log(
    //  'NEUES - VORHER:',
    //  previousNewEvent
    //);

    //console.log(
    //  'NEUES - NACHHER:',
    //  nextNewEvent
    //);

    // ======================================================
    // EVENTS DIE AKTUALISIERT WERDEN
    // ======================================================

    const mainEvents = [
      previousOldEvent,
      nextOldEvent,
      previousNewEvent,
      nextNewEvent,
    ]
      .filter(Boolean)
      .filter(
        (event, index, array) =>
          array.findIndex((e) => e.id === event.id) === index,
      );

    //console.log('<----- UPDATED BUFFER MAIN EVENTS ----->',mainEvents);

    // ======================================================
    // NACHBAR-EVENTS AKTUALISIEREN
    // ======================================================

    for (const event of mainEvents) {
      const eventResources = getResourceIds(event.resource);

      if (!eventResources.length) {
        continue;
      }

      // Für das Buffer-Update die Resource nehmen,
      // die tatsächlich zu diesem Event gehört.
      const resource = eventResources[0];

      const eventStartDate = this.normalizeToDate(event.start);

      if (!eventStartDate) {
        continue;
      }

      const eventDate = eventStartDate.toISOString().split('T')[0];

      //console.log('UPDATE NACHBAR', event.id, 'RESOURCE:', resource);

      // ----------------------------------------------------
      // BUFFER BEFORE
      // ----------------------------------------------------

      const bufferBeforeObj = await this.bufferService.getBufferBefore(
        event,
        this.myEvents,
        resource,
        eventStartDate,
        eventDate,
      );

      // ----------------------------------------------------
      // BUFFER AFTER
      // ----------------------------------------------------

      const bufferAfterObj = await this.bufferService.getBufferAfter(
        event,
        this.myEvents,
        resource,
        eventStartDate,
        eventDate,
      );

      event['previousEventLocation'] = bufferBeforeObj.previousEventLocation;

      event['earlierEvent'] = bufferBeforeObj.earlierEvent;

      event.bufferBefore = bufferBeforeObj.bufferBefore || 0;

      event['nextEventLocation'] = bufferAfterObj.nextEventLocation;

      event['nextEvent'] = bufferAfterObj.nextEvent;

      event.bufferAfter = bufferAfterObj.bufferAfter || 0;
    }

    // ======================================================
    // VERSCHOBENES EVENT SELBST AKTUALISIEREN
    // ======================================================

    const updatedEventInList = this.myEvents.find(
      (event) => event.id === updatedEvent.id,
    );

    if (
      updatedEventInList &&
      updatedEventInList['calculateTraveltime'] &&
      !updatedEventInList['isTempEvent']
    ) {
      const eventResources = getResourceIds(updatedEventInList.resource);

      if (eventResources.length) {
        const resource = eventResources[0];

        const startDate =
          this.normalizeToDate(updatedEventInList.start) || updatedStartDate;

        if (startDate) {
          const currentDate = startDate.toISOString().split('T')[0];

          const bufferBeforeObj = await this.bufferService.getBufferBefore(
            updatedEventInList,
            this.myEvents,
            resource,
            startDate,
            currentDate,
          );

          const bufferAfterObj = await this.bufferService.getBufferAfter(
            updatedEventInList,
            this.myEvents,
            resource,
            startDate,
            currentDate,
          );

          updatedEventInList['previousEventLocation'] =
            bufferBeforeObj.previousEventLocation;

          updatedEventInList['earlierEvent'] = bufferBeforeObj.earlierEvent;

          updatedEventInList.bufferBefore = bufferBeforeObj.bufferBefore || 0;

          updatedEventInList['nextEventLocation'] =
            bufferAfterObj.nextEventLocation;

          updatedEventInList['nextEvent'] = bufferAfterObj.nextEvent;

          updatedEventInList.bufferAfter = bufferAfterObj.bufferAfter || 0;
        }
      }
    }

    // ======================================================
    // TEMPORÄRE WERTE ENTFERNEN
    // ======================================================

    for (const event of this.myEvents) {
      delete event['_startTs'];
      delete event['_endTs'];
    }

    // ======================================================
    // CHANGE DETECTION
    // ======================================================

    this.myEvents = [...this.myEvents];
  }

  normalizeToDate(value: any): Date | null {
    if (!value) return null;

    // Fall 1: Bereits Date
    if (value instanceof Date) return value;

    // Fall 2: String
    if (typeof value === 'string') return new Date(value);

    // Fall 3: Mobiscroll-Objekt mit date-Feld
    if (typeof value === 'object' && 'date' in value) {
      return new Date(value.date);
    }

    // Unbekanntes Format → ignorieren
    return null;
  }

  async cleanRecurring(event: any) {
    let cleanedObj;
    event.recurring.interval =
      parseInt(event.recurring.interval as any, 10) || (null as any);

    if (event.recurring.count != null) {
      event.recurring.count =
        parseInt(event.recurring.count as any, 10) || (null as any);
    }

    if (
      typeof event.recurring.until === 'string' &&
      event.recurring.until.includes('T')
    ) {
      event.recurring.until = event.recurring.until.split('T')[0]; // '2025-06-06'
    }

    let localExceptions: string[] = [];

    if (Array.isArray(event.recurringException)) {
      localExceptions = event.recurringException.map((entry: string) => {
        const date = new Date(entry as string); // sicher casten
        return date.toLocaleDateString('sv-SE'); // 'YYYY-MM-DD'
      });
      event.recurringException = localExceptions;
    }

    if (event.recurring.until) {
      event.condition = 'until';
    } else if (event.recurring.count) {
      event.condition = 'count';
    } else {
      event.condition = 'never';
    }

    const obj = event.recurring;
    cleanedObj = Object.fromEntries(
      Object.entries(obj).filter(
        ([_, value]) => value !== null && value !== undefined,
      ),
    );

    return cleanedObj;
  }

  // Ein Event mit mehreren Resourcen wird gesplittet in TempEvents.
  // Hier werden diese geupdatet und zusätzlich die Nachbarevents
  // der alten und neuen Resourcen neu berechnet.
  async updateTempEvents(mobiscrollEvent: any) {
    const currentStart = new Date(mobiscrollEvent.start);
    const currentDate = currentStart.toISOString().split('T')[0];

    // ---------------------------------------------------------
    // 1. Alte und neue Resourcen ermitteln
    // ---------------------------------------------------------

    let oldResources;

    if (!this.originalEventData.isTempEvent) {
      oldResources = this.originalEventData.resource;
    } else {
      oldResources = this.originalEventData.eventResources;
    }

    const newResources = mobiscrollEvent.resource;

    const newResource = newResources.find(
      (resource: number) => !oldResources.includes(resource),
    );

    const oldResource = Number(this.originalEventData.resource);

    // ---------------------------------------------------------
    // 2. Events der alten/neuen Resource finden
    // ---------------------------------------------------------

    //Alle alten Events
    const oldResourceEvents = this.myEvents
      .filter((event: any) => {
        return Number(event.resource) === oldResource;
      })
      .filter((event: any) => {
        return event.refId !== mobiscrollEvent.id;
      })
      .sort(
        (a: any, b: any) =>
          new Date(a.start as string | Date).getTime() -
          new Date(b.start as string | Date).getTime(),
      );

    //Alle neuen Events
    const newResourceEvents = this.myEvents
      .filter((event: any) => {
        return Number(event.resource) === newResource;
      })
      .filter((event: any) => {
        return event.refId !== mobiscrollEvent.id;
      })
      .sort(
        (a: any, b: any) =>
          new Date(a.start as string | Date).getTime() -
          new Date(b.start as string | Date).getTime(),
      );

    //Hilfsfunktion ob am selben Tag
    const isSameDay = (date1: Date, date2: Date): boolean => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };

    //Events davor und danach finden
    const eventsToUpdate = [];

    const movedEventStart = new Date(mobiscrollEvent.start).getTime();
    const movedEventEnd = new Date(mobiscrollEvent.end).getTime();

    //Altes Event davor
    const previousEventOld = oldResourceEvents
      .filter((event: any) => {
        if (!event.end) return false;

        const eventEnd = new Date(event.end as any);

        return (
          isSameDay(eventEnd, new Date(movedEventStart)) &&
          eventEnd.getTime() <= movedEventStart
        );
      })
      .pop();

    if (previousEventOld) {
      eventsToUpdate.push(previousEventOld);
    }

    //Altes Event danach
    const nextEventOld = oldResourceEvents.find((event: any) => {
      if (!event.start) return false;

      const eventStart = new Date(event.start as any);

      return (
        isSameDay(eventStart, new Date(movedEventEnd)) &&
        eventStart.getTime() >= movedEventEnd
      );
    });

    if (nextEventOld) {
      eventsToUpdate.push(nextEventOld);
    }

    //Neues Event davor
    const previousEventNew = newResourceEvents
      .filter((event: any) => {
        if (!event.end) return false;

        const eventEnd = new Date(event.end as any);

        return (
          isSameDay(eventEnd, new Date(movedEventStart)) &&
          eventEnd.getTime() <= movedEventStart
        );
      })
      .pop();

    if (previousEventNew) {
      eventsToUpdate.push(previousEventNew);
    }

    //Neues Event danach
    const nextEventNew = newResourceEvents.find((event: any) => {
      if (!event.start) return false;

      const eventStart = new Date(event.start as any);

      return (
        isSameDay(eventStart, new Date(movedEventEnd)) &&
        eventStart.getTime() >= movedEventEnd
      );
    });

    if (nextEventNew) {
      eventsToUpdate.push(nextEventNew);
    }

    // ---------------------------------------------------------
    // 3. Events zum Update vorbereiten (Buffer aktualisieren)
    // ---------------------------------------------------------

    for (const event of eventsToUpdate) {
      const resource = Number(event.resource);

      const bufferBeforeObj = await this.bufferService.getBufferBefore(
        event,
        this.myEvents,
        resource,
        currentStart,
        currentDate,
      );

      const bufferAfterObj = await this.bufferService.getBufferAfter(
        event,
        this.myEvents,
        resource,
        currentStart,
        currentDate,
      );

      const previousEventLocation = bufferBeforeObj.previousEventLocation;
      const earlierEvent = bufferBeforeObj.earlierEvent;
      const nextEventLocation = bufferAfterObj.nextEventLocation;
      const nextEvent = bufferAfterObj.nextEvent;

      if (event['calculateTraveltime']) {
        event.bufferBefore = bufferBeforeObj.bufferBefore || 0;
        event.bufferAfter = bufferAfterObj.bufferAfter || 0;
      }

      event['previousEventLocation'] = previousEventLocation;
      event['earlierEvent'] = earlierEvent;
      event['nextEventLocation'] = nextEventLocation;
      event['nextEvent'] = nextEvent;

      delete event.recurring;
    }

    // ---------------------------------------------------------
    // 4. Alte Events aus dem Event Array entfernen und neue einfügen
    // ---------------------------------------------------------

    for (const eventUpdate of eventsToUpdate) {
      this.myEvents = this.myEvents.filter(
        (event: any) => event.id !== eventUpdate.id,
      );
      this.myEvents.push(eventUpdate);
    }
  }

  clearHighlightsOnClickOutside = () => {
    if (this.highlightedTimes.length > 0) {
      this.highlightedTimes = this.highlightedTimes.filter(
        (item) => item.background !== '#ffeeba',
      );
      if (this.cdr?.detectChanges) {
        this.cdr.detectChanges();
      }
    }
  };

  onEventDeleted(eventId: number) {
    this.myEvents = this.myEvents.filter((event) => event.id !== eventId);
    this.cdr.detectChanges();
  }

  async onEventOpenWIthId(args: any) {
    const startOfDay = new Date(args.start);
    startOfDay.setHours(0, 0, 0, 0);

    const endOfDay = new Date(startOfDay);
    endOfDay.setHours(23, 59, 59, 999);

    const startDate = startOfDay.toISOString().split('T')[0];
    const endDate = endOfDay.toISOString().split('T')[0];

    this.getEventService.fetchEvents(startDate, endDate).subscribe(
      (events) => {
        // Events unverändert übernehmen
        this.myEvents = events;

        const matchedEvent = this.myEvents.find(
          (event: any) => String(event.id) === String(args.id),
        );

        if (!matchedEvent) {
          console.warn('Event nicht gefunden');
          return;
        }

        // Kalender auf das Event navigieren
        this.calendar.navigateToEvent(matchedEvent);

        // Datum setzen
        if (matchedEvent.start) {
          this.onDateChange(matchedEvent.start);
        }

        this.selectedEvent = [matchedEvent];

        // Popup öffnen
        this.openEventWithId(matchedEvent);

        // Event-ID aus URL entfernen, Datum behalten
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { eventId: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      },
      (error) => {
        console.error('Fehler beim Abrufen der Events:', error);
      },
    );
  }

  formatLocalDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  async onEventClicked(args: any) {
    //console.log(this.startOfDay)
    const startOfDay = new Date(args.event.start);
    startOfDay.setHours(0, 0, 0, 0);

    const endOfDay = new Date(startOfDay);
    endOfDay.setHours(23, 59, 59, 999);

    const startDateFormatted = this.formatLocalDate(startOfDay);
    const endDateFormatted = this.formatLocalDate(endOfDay);

    if (startOfDay.getTime() === this.startOfDay.getTime()) {
      const matchedEvent = this.myEvents.find((e) => e.id === args.event.id);

      if (matchedEvent) {
        matchedEvent['onlineLink'] = this.normalizeOnlineLink(
          matchedEvent['onlineLink'],
        );
        this.calendar.navigateToEvent(matchedEvent);

        if (matchedEvent.start) {
          this.onDateChange(matchedEvent.start);
        }

        this.selectedEvent = [matchedEvent];
        if (matchedEvent.resource === null) {
          this.openBacklogEvent(matchedEvent);
        } else {
          this.openEventWithId(matchedEvent);
          //console.log("Matched Event:", matchedEvent)
        }
      } else {
        console.warn('Event nicht gefunden');
      }
    } else {
      this.getEventService
        .fetchEvents(startDateFormatted, endDateFormatted)
        .subscribe(
          (events) => {
            this.myEvents = events.map((event: any) => ({
              ...event,
              start: new Date(event.start),
              end: new Date(event.end),
            }));

            //console.log('this.myEvents : ',this.myEvents);

            const matchedEvent = this.myEvents.find(
              (e) => e.id === args.event.id,
            );

            //console.log('Matched Event on Click:', matchedEvent);

            if (matchedEvent) {
              matchedEvent['onlineLink'] = this.normalizeOnlineLink(
                matchedEvent['onlineLink'],
              );
              this.calendar.navigateToEvent(matchedEvent);

              if (matchedEvent.start) {
                this.onDateChange(matchedEvent.start);
              }

              this.selectedEvent = [matchedEvent];
              if (matchedEvent.resource === null) {
                this.openBacklogEvent(matchedEvent);
              } else {
                this.openEventWithId(matchedEvent);
                //console.log("Matched Event:", matchedEvent)
              }
            } else {
              console.warn('Event nicht gefunden');
            }
          },
          (error) => {
            console.error('Fehler beim Abrufen der Events:', error);
          },
        );
    }
  }

  //Hier werden die invalids geupdated nach Änderungen
  updateCalendarOptions() {
    this.calendarOptions = {
      ...this.calendarOptions,
      selectedDate: this.startOfDay,
      invalid: this.invalids,
    };
  }

  async onDateChange(selectedDate: MbscDateType) {
    //this.saveScrollPosition();
    //this.getHorizontalScroll();

    if (!selectedDate) {
      console.error('Das übergebene Datum ist undefined.');
      return;
    }

    if (typeof selectedDate === 'string' || typeof selectedDate === 'number') {
      selectedDate = new Date(selectedDate);
    }

    if (!(selectedDate instanceof Date) || isNaN(selectedDate.getTime())) {
      console.error('Ungültiges Datum:', selectedDate);
      return;
    }

    //console.log(this.lastVisibleTime)
    const startDate = new Date(selectedDate);
    if (this.lastVisibleTime) {
      const hours = this.lastVisibleTime.hours;
      const minutes = this.lastVisibleTime.minutes;
      startDate.setHours(hours, 0, 0, 0);
      startDate.setMinutes(minutes, 0, 0);
      //console.log('new StartDate: ',startDate)
    } else {
      startDate.setHours(7, 0, 0, 0);
    }

    if (this.lastLoadedDate === startDate.getTime()) return;
    this.lastLoadedDate = startDate.getTime();

    // ✅ interne Speicherung als Date
    this.startOfDay = new Date(startDate);
    this.endOfDay = new Date(startDate);
    this.endOfDay.setHours(23, 59, 59, 999);

    const yesterdayDate = new Date(this.startOfDay);
    yesterdayDate.setDate(this.startOfDay.getDate() - 1);
    this.yesterday = yesterdayDate;

    // ✅ API-Aufrufe mit formatierten Strings
    setTimeout(async () => {
      const startStr = this.formatLocalDate(this.startOfDay);
      const endStr = this.formatLocalDate(this.endOfDay);
      const yStr = this.formatLocalDate(this.yesterday);

      await this.weekTemplateComp.fetchEventStatsWithTime(endStr);
      await this.fetchInterpretersWithTime(endStr);
      await this.fetchEvents(yStr, endStr);
      // await this.fetchEventsWithErrors(startStr);
      await this.fetchBlocker(startStr, endStr);
      await this.fetchPrivateEvents(startStr);
    }, 100);

    //Datum setzen in der Url
    const formattedDate = startDate.toISOString().split('T')[0];

    this.router.navigate(['/admin-calendar', formattedDate], {
      replaceUrl: true,
    });

    this.updateCalendarOptions();
    this.selectedDate = startDate;
    this.dateChangeService.setSelectedDate(startDate);
  }

  //Scrollt zu dem angewählten Datum und Uhrzeit.
  scrollToDate() {
    setTimeout(() => {
      const container = document.querySelector(
        '.mbsc-timeline-grid-scroll',
      ) as HTMLElement;

      if (container && this.selectedDate) {
        const date = this.selectedDate as Date;
        const hours = date.getHours();
        const minutes = date.getMinutes();

        // px pro Minute – muss evtl. an deine Timeline-Breite angepasst werden
        const pxPerMinute = 2;
        const scrollPos = (hours * 60 + minutes) * pxPerMinute;
        container.scrollLeft = scrollPos;
      }
    }, 800);
  }

  scrollToPreviousTime(scroll: number) {
    setTimeout(() => {
      const container = document.querySelector(
        '.mbsc-timeline-grid-scroll',
      ) as HTMLElement | null;
      if (container) {
        container.scrollLeft = scroll;
      }
    }, 800);
  }

  async sortInterpreters() {
    const savedFilters = JSON.parse(
      localStorage.getItem('calendarFilters') || '{}',
    );

    if (!this.myResources || this.myResources.length === 0) return;
    if (!this.stammteamData || this.stammteamData.length === 0) return;

    const filteredResources = this.myResources.filter(
      (user) => user.workingType !== 'Fremd Dolmetscher',
    );

    const teamMap: Record<string, any> = {};

    this.stammteamData.forEach((team: any) => {
      teamMap[team.name] = {
        id: team.name,
        name: team.name,
        color: team.color,
        eventCreation: !!team.eventCreation,
        eventDragBetweenResources: !!team.eventDragBetweenResources,
        eventDragInTime: !!team.eventDragInTime,
        eventResize: !!team.eventResize,
        eventoverlap: !!team.eventoverlap,
        fixed: !!team.fixed,
        collapsed: !!team.collapsed,
        isParent: !!team.isParent,
        children: [],
      };
    });

    filteredResources.forEach((user: any) => {
      const team = this.stammteamData.find((t: any) => t.id === user.teamId);

      if (!team) return;

      const teamName = team.name;

      if (teamMap[teamName]) {
        teamMap[teamName].children.push(user);
      }
    });

    Object.values(teamMap).forEach((team: any) => {
      team.children.sort((a: any, b: any) => {
        const nameA = String(a.lastName ?? '') + String(a.firstName ?? '');
        const nameB = String(b.lastName ?? '') + String(b.firstName ?? '');

        return nameA.localeCompare(nameB, 'de', { sensitivity: 'base' });
      });
    });

    let teamOrder: string[] = this.stammteamData.map((t: any) => t.name);

    const savedOrder = localStorage.getItem('teamOrder');
    if (savedOrder) {
      teamOrder = JSON.parse(savedOrder);
    } else {
      localStorage.setItem('teamOrder', JSON.stringify(teamOrder));
    }

    const fixedTeamId = localStorage.getItem('fixedTeam');

    if (fixedTeamId !== null && teamOrder.includes(fixedTeamId)) {
      teamOrder = teamOrder.filter((id) => id !== fixedTeamId);
      teamOrder.unshift(fixedTeamId);
    }

    this.mySortedResources = teamOrder
      .map((id) => teamMap[id])
      .filter(Boolean)
      .filter((team) => team.children && team.children.length > 0)
      .map((team) => ({
        ...team,
        fixed: team.id === fixedTeamId,
        children: team.children.map((child: any) => ({
          ...child,
          fixed: false,
        })),
      }));

    this.filterResourcesService.teamFilters = [];
    this.filterResourcesService.interpreterFilters = [];
    this.filterResourcesService.otherFilters = [];
    this.filterResourcesService.myFilters = [];

    this.mySortedResources.forEach((group) => {
      const groupFilter = {
        id: group.id,
        name: group.name,
        value: savedFilters[String(group.id)] ?? true,
        disabled: false,
      };

      // Falls du "Allgemein" speziell behandeln willst:
      if (group.name === 'Allgemein') {
        this.filterResourcesService.otherFilters.push(groupFilter);
      } else {
        this.filterResourcesService.teamFilters.push(groupFilter);
      }
      // this.filterResourcesService.teamFilters.push(groupFilter);

      group.children?.forEach((resource: any) => {
        const resFilter = {
          id: resource.id,
          name: resource.name,
          value: savedFilters[String(resource.id)] ?? true,
          disabled: false,
        };

        this.filterResourcesService.interpreterFilters.push(resFilter);
        this.filterResourcesService.myFilters.push(resFilter);
      });
    });

    //this.filterResourcesService.filteredResources = this.mySortedResources;
    this.filterResourcesService.mySortedResources = this.mySortedResources;

    const currentFilters: { [key: string]: boolean } = {};

    [
      ...this.filterResourcesService.teamFilters,
      ...this.filterResourcesService.interpreterFilters,
    ].forEach((filter) => {
      currentFilters[String(filter.id)] = filter.value;
    });

    this.filterResourcesService.filterResources(currentFilters, '');

    const savedCollapsed = localStorage.getItem('collapsedTeams');
    if (savedCollapsed) {
      const savedTeams = JSON.parse(savedCollapsed);
      this.showOnlyTeam(savedTeams);
    }
  }

  onFixTeam(team: any) {
    const defaultOrder = [
      'Allgemein',
      'teamTuerkis',
      'teamBlau',
      'teamGruen',
      'teamOrange',
      'trainee',
    ];

    const savedOrder = localStorage.getItem('teamOrder');
    let order: string[] = savedOrder
      ? JSON.parse(savedOrder)
      : [...defaultOrder];

    const savedFixed = localStorage.getItem('fixedTeam');

    if (savedFixed === team.id) {
      localStorage.removeItem('fixedTeam');
      order = [...defaultOrder];
    } else {
      localStorage.setItem('fixedTeam', team.id);

      order = order.filter((id) => id !== team.id);
      order.unshift(team.id);
    }

    localStorage.setItem('teamOrder', JSON.stringify(order));

    this.sortInterpreters();
  }

  onUnfixTeam(team: any) {
    localStorage.removeItem('fixedTeam');
    const savedOrder = localStorage.getItem('teamOrder');
    if (!savedOrder) {
      const defaultOrder = [
        'Allgemein',
        'teamTuerkis',
        'teamBlau',
        'teamGruen',
        'teamOrange',
        'trainee',
      ];
      localStorage.setItem('teamOrder', JSON.stringify(defaultOrder));
    }

    this.sortInterpreters();
  }

  handleTeamSelect(openTeams: string[]) {
    this.selectedKey = openTeams;
    this.showOnlyTeam(openTeams);
  }

  showOnlyTeam(collapsedTeams: string[]) {
    if (!Array.isArray(collapsedTeams)) {
      console.error('collapsedTeams ist kein Array!', collapsedTeams);
      return;
    }

    this.mySortedResources = this.mySortedResources.map((group) => ({
      ...group,
      collapsed: collapsedTeams.includes(String(group.id)),
    }));

    const currentFilters: { [key: string]: boolean } = {};

    [
      ...this.filterResourcesService.teamFilters,
      ...this.filterResourcesService.interpreterFilters,
    ].forEach((filter) => {
      currentFilters[String(filter.id)] = filter.value;
    });

    this.filterResourcesService.mySortedResources = this.mySortedResources;

    this.filterResourcesService.filterResources(currentFilters, '');
  }

  // Abruf der Resourcen mit Datum
  fetchInterpretersWithTime(endTime: any) {
    const endDateStr = new Date(endTime).toISOString().split('T')[0];
    this.fetchUserService.fetchInterpretersWithTime(endDateStr).subscribe(
      (users: any) => {
        const Interpreter: Resource[] = users.map((user: any) => ({
          id: user.id,
          cr: user.abbreviation,
          name: `${user.firstName.trim()} ${user.lastName}`,
          color: user.color,
          background: this.colorService.lightenColor(user.color, 90),
          img: user.img,
          workingHours: user.workingHours,
          workingType: user.workingType,
          team: user.name,
          teamId: user.teamId,
          HOLIDAYEVENT_dayCount: user.HOLIDAYEVENT_dayCount,
          HOLIDAYEVENT_minutes: user.HOLIDAYEVENT_minutes,
          MEETINGEVENT_minutes: user.MEETINGEVENT_minutes,
          MISSIONEVENT_minutes: user.MISSIONEVENT_minutes,
          SICKEVENT_dayCount: user.SICKEVENT_dayCount,
          SICKEVENT_minutes: user.SICKEVENT_minutes,
          TOTAL_minutes: user.TOTAL_minutes,
          TOTAL_minutes_day: user.TOTAL_minutes_day,
          ueberstunden: user.ueberstunden,
          isExt: user.isExt,
          o365Id: user.o365Id,
        }));

        if (this.myResources) {
          this.myResources = Interpreter;
          //console.log(this.myResources);
          this.findExternResources();
          this.sortInterpreters();
        }
      },
      (error) => {
        console.error('Fehler beim Abrufen der Dolmetscher:', error);
      },
    );
  }

  findExternResources() {
    this.extResources = [];
    this.myResources.filter((resource) => {
      if (resource.isExt) {
        this.extResources.push(resource.id);
      }
    });
  }

  // Abruf der Resourcen
  fetchInterpreters() {
    this.fetchUserService.fetchInterpreters().subscribe(
      (users: any) => {
        const Interpreter: Resource[] = users.map((user: any) => ({
          id: user.id,
          cr: user.abbreviation,
          name: `${user.firstName.trim()} ${user.lastName}`,
          color: user.color,
          background: this.colorService.lightenColor(user.color, 90),
          img: user.img,
          workingHours: user.workingHours,
          workingType: user.workingType,
          team: user.team,
        }));

        if (this.myResources) {
          this.myResources = Interpreter;
          this.sortInterpreters();
        }
      },
      (error) => {
        console.error('Fehler beim Abrufen der Dolmetscher:', error);
      },
    );
  }

  onMoveToSideBarCompleted() {
    setTimeout(() => {
      this.fetchEvents(this.startOfDay, this.endOfDay);
    });
  }

  //Hier werden die Events abgerufen und verarbeitet
  async fetchEvents(startOfDay: any, endOfDay: any) {
    const formattedStart = this.formatLocal(new Date(startOfDay));
    const formattedEnd = this.formatLocal(new Date(endOfDay));

    try {
      const events = await firstValueFrom(
        this.getEventService.fetchEvents(formattedStart, formattedEnd),
      );
      this.mySidebarEvents = events;
      this.allEvents = events;
      const eventPromises = events.map(async (event: any) => {
        try {
          this.customerArray = event.customer;
          let cleanedObj;
          if (event.recurring) {
            event.recurring.interval =
              parseInt(event.recurring.interval as any, 10) || (null as any);

            if (event.recurring.count != null) {
              event.recurring.count =
                parseInt(event.recurring.count as any, 10) || (null as any);
            }

            if (
              typeof event.recurring.until === 'string' &&
              event.recurring.until.includes('T')
            ) {
              event.recurring.until = event.recurring.until.split('T')[0];
            }

            let localExceptions: string[] = [];

            if (Array.isArray(event.recurringException)) {
              localExceptions = event.recurringException.map(
                (entry: string) => {
                  const date = new Date(entry as string);
                  return date.toLocaleDateString('sv-SE');
                },
              );
              event.recurringException = localExceptions;
            }

            if (event.recurring.until) {
              event.condition = 'until';
            } else if (event.recurring.count) {
              event.condition = 'count';
            } else {
              event.condition = 'never';
            }

            const obj = event.recurring;
            cleanedObj = Object.fromEntries(
              Object.entries(obj).filter(
                ([_, value]) => value !== null && value !== undefined,
              ),
            );

            if (!this.isEmptyObject(cleanedObj)) {
              event.recurring = cleanedObj;
            } else {
              delete event.recurring;
            }
          }

          if (
            event.resource.length > 1 ||
            event.resource.length < event.dolmetscher
          ) {
            return await this.createTempEvent(event, events);
          } else {
            let previousEventLocation;
            let earlierEvent;
            let bufferBefore;

            let nextEventLocation;
            let nextEvent;
            let bufferAfter;

            if (
              event.calculateTraveltime &&
              this.traveltimeService.calcTraveltimeGlobal
            ) {
              const currentStart = new Date(event.start);

              const currentDate = currentStart.toISOString().split('T')[0];
              const bufferBeforeObj = await this.bufferService.getBufferBefore(
                event,
                events,
                event.resource[0],
                currentStart,
                currentDate,
              );
              const bufferAfterObj = await this.bufferService.getBufferAfter(
                event,
                events,
                event.resource[0],
                currentStart,
                currentDate,
              );

              previousEventLocation = (await bufferBeforeObj)
                .previousEventLocation;
              earlierEvent = (await bufferBeforeObj).earlierEvent;
              bufferBefore = (await bufferBeforeObj).bufferBefore;

              nextEventLocation = (await bufferAfterObj).nextEventLocation;
              nextEvent = (await bufferAfterObj).nextEvent;
              bufferAfter = (await bufferAfterObj).bufferAfter;

              //if ((event.traveltimeBefore === null || event.traveltimeAfter === null) && event.location !== '' && !event.online) {
              //  const traveltimeData = await this.traveltimeService.getTraveltime(event.location);
              //  event.traveltimeBefore = traveltimeData.duration;
              //  event.traveltimeAfter = traveltimeData.duration;
              //}
            } else {
              bufferBefore = event.traveltimeBefore;
              bufferAfter = event.traveltimeAfter;
            }

            let platforms = [];

            platforms = this.normalizeOnlineLink(event.onlineLink);

            let informations;

            if (event.informations !== '') {
              informations = JSON.parse(event.informations);

              if (informations === null) {
                informations = '';
              } else if (informations.length === 0 && informations !== null) {
                informations = '';
              }
            } else {
              informations = '';
            }

            //SKILL-SERVICE
            event.skillWarn = this.skillService.checkSkillsAndKundenteam(event);

            //CHECK OB EVENT ALS COLOR DARGESTELLT WERDEN SOLL
            const eventAsColor = this.checkEventAsColor(event);

            if (eventAsColor) {
              return [];
            }

            return [
              {
                id: event.id,
                isTemplate: event.isTemplate,
                title: event.title,
                start: new Date(event.start),
                end: new Date(event.end),
                location: event.location,
                color: this.colorService.getStatusColor(event),
                description: event.description,
                cost: event.cost,
                status: event.status,
                category: event.category,
                resource: event.resource,
                type: event.type,
                customer: event.customer,
                createdAt: event.created_at,
                bestaetigungsform: event.bestaetigungsform,
                blocker: event.blocker,
                blockerRef: event.blockerRef,
                bufferAfter: bufferAfter,
                bufferBefore: bufferBefore,
                calculateTraveltime: event.calculateTraveltime,
                deleted: event.deleted,
                dolmetscher: event.dolmetscher,
                einsatzzeit: event.einsatzzeit,
                offeneTermine: event.offeneTermine,
                online: event.online,
                onlineLink: platforms,
                recurringids: event.recurringids,
                ticketno: event.ticketno,
                traveltime: event.traveltime,
                vorbereitungsmaterial: event.vorbereitungsmaterial,
                vorbereitungsmaterialLink: event.vorbereitungsmaterialLink,
                recurring: event.recurring ? cleanedObj : undefined,
                recurringException: event.recurringException,
                condition: event.condition,
                previousEventLocation,
                hasEarlierSameDayEvent: !!earlierEvent,
                nextEventLocation,
                hasNextSameDayEvent: !!nextEvent,
                dialinTime: event.dialinTime,
                minuteBased: event.minuteBased,
                subtypes: event.subtypes,
                informations: informations,
                traveltimeBefore: event.traveltimeBefore,
                traveltimeAfter: event.traveltimeAfter,
                aufzeichnung: event.aufzeichnung,
                vorbereitung: event.vorbereitung,
                vorbereitungZeit: event.vorbereitungZeit,
                ueberprueft: event.ueberprueft,
                resourceMeta: event.resourceMeta,
                skillWarn: event.skillWarn,
                abrechnungArt: event.abrechnungArt,
                fremdCoAbrechnung: event.fremdCoAbrechnung,
              },
            ];
          }
        } catch (e) {
          console.error('Fehler bei Event', event.id, e);
          return null;
        }
      });
      this.myEvents = (await Promise.all(eventPromises)).flat();
      if (this.myEvents) {
        this.myEventsCopy = [...this.myEvents];
        const updatedResources =
          this.calcTraveltimeService.getTraveltimesForResources(
            this.myEvents,
            this.filterResourcesService.filteredResources,
            this.dateChangeService.selectedDateSource.value,
          );

        this.filterResourcesService.filteredResources = updatedResources.map(
          (team: any) => ({
            ...team,
            children: Array.isArray(team.children)
              ? team.children.map((resource: any) => ({ ...resource }))
              : [],
          }),
        );
      }
      if (this.highlightedTimes) {
        this.highlightedTimesCopy = [...this.highlightedTimes];
      }

      this.appendResttime(events, startOfDay);
      this.cdr.detectChanges();

      const endOfDayDate = new Date(endOfDay);

      const targetStart = new Date(endOfDayDate);
      targetStart.setHours(0, 0, 0, 0);

      const targetEnd = new Date(endOfDayDate);
      targetEnd.setHours(23, 59, 59, 999);

      this.tasks = this.mySidebarEvents
        .filter((event: any) => {
          if (!event || !event.start || !event.end) return false;
          if (event.isTemplate !== 0) return false;

          const eventStart = new Date(event.start);
          const eventEnd = new Date(event.end);
          const overlaps = eventStart <= targetEnd && eventEnd >= targetStart;

          if (!overlaps) return false;

          const dolmetscherCount = Number(event.dolmetscher) || 0;

          let resourceCount = 0;
          let hasNullResource = false;
          if (Array.isArray(event.resource)) {
            const validResources = event.resource.filter((r: any) => {
              if (r === null) hasNullResource = true;
              return r != null;
            });
            resourceCount = validResources.length;
          } else if (
            typeof event.resource === 'number' ||
            typeof event.resource === 'string'
          ) {
            resourceCount = 1;
          }
          let fremdDolmetscherCount = 0;

          let infoArray: any[] = [];

          if (
            typeof event.informations === 'string' &&
            event.informations.trim() !== ''
          ) {
            try {
              infoArray = JSON.parse(event.informations);
            } catch (e) {
              console.warn(
                '⚠️ Fehler beim Parsen von event.informations:',
                event.informations,
                e,
              );
              infoArray = [];
            }
          } else if (Array.isArray(event.informations)) {
            infoArray = event.informations;
          }

          if (Array.isArray(infoArray)) {
            infoArray.forEach((info: any) => {
              const title = (info.title || info.icon_name || '').toLowerCase();

              if (
                (title.includes('fremd') && title.includes('dolmetscher')) ||
                title.includes('fremd-co') ||
                title.includes('fremddolmetscher')
              ) {
                if (info.checked) {
                  if (Array.isArray(info.options) && info.options.length > 0) {
                    fremdDolmetscherCount += info.options.length;
                  } else {
                    fremdDolmetscherCount += 1;
                  }
                }
              }
            });
          }

          const totalAssigned = resourceCount + fremdDolmetscherCount;
          const fehlendeDolmetscher = Math.max(
            0,
            dolmetscherCount - totalAssigned,
          );

          const shouldGoToBacklog =
            hasNullResource || resourceCount === 0 || fehlendeDolmetscher > 0;

          event.resourceCount = resourceCount;
          event.fremdDolmetscherCount = fremdDolmetscherCount;
          event.totalAssigned = totalAssigned;
          event.fehlendeDolmetscher = fehlendeDolmetscher;
          event.hasNullResource = hasNullResource;

          return shouldGoToBacklog;
        })
        .map((event) => {
          const startString =
            typeof event.start === 'string'
              ? event.start
              : event.start instanceof Date
                ? event.start.toISOString().slice(0, 16)
                : '2025-01-01T00:00';

          const endString =
            typeof event.end === 'string'
              ? event.end
              : event.end instanceof Date
                ? event.end.toISOString().slice(0, 16)
                : '2025-01-01T01:00';

          const startDate = new Date(startString);
          const endDate = new Date(endString);
          const durationInMinutes =
            (endDate.getTime() - startDate.getTime()) / 60000;
          const length = `${(durationInMinutes / 60).toFixed(1)} Std.`;

          return {
            ...event,
            start: event.start,
            end: event.end,
            length,
          };
        });

      this.filteredTasks = this.tasks.sort(
        (a: any, b: any) =>
          new Date(a.start).getTime() - new Date(b.start).getTime(),
      );
    } catch (error) {
      console.error('Fehler beim Abrufen der Event-Daten (extern):', error);
    }
  }

  isEmptyObject(obj: unknown): obj is Record<string, never> {
    return (
      obj !== null &&
      typeof obj === 'object' &&
      !Array.isArray(obj) &&
      !(obj instanceof Date) &&
      Object.keys(obj).length === 0
    );
  }

  //ES WIRD GEPRÜFT OB EVENT ALS COLOR ANGEZEIGT WERDEN SOLL
  checkEventAsColor(event: any) {
    let typesAsColor = [
      'HOMEOFFICEHOURLYEVENT',
      'PARENTALLEAVE',
      'HOLIDAY',
      'COMPANYHOLIDAY',
      'HOMEOFFICEEVENT',
      'CAREERENTRYEVENT',
      'ILLNESSREPRESENTATIONEVENT',
      'ILLNESSREPRESENTATIONFLEX',
      'MEDICALBLOCKEREVENT',
      'STUDENTBLOCKEREVENT',
      'FLEXBLOCKEREVENT',
    ];

    if (typesAsColor.includes(event.type)) {
      const newColorEvent = {
        ...event,
        start: new Date(event.start as any),
        end: new Date(event.end as any),
      };

      newColorEvent.cssClass = this.getColorCssClass(event.type);
      this.highlightedTimes = this.highlightedTimes.filter(
        (color) => color.id !== newColorEvent.id,
      );

      this.highlightedTimes = [...this.highlightedTimes, newColorEvent];

      return true;
    } else return false;
  }

  //GIBT DIE CSS KLASSE ZURÜCK !!!-> class bei appendResttime() einpflegen!
  getColorCssClass(type: any) {
    switch (type) {
      case 'HOMEOFFICEHOURLYEVENT':
        return 'homeoffice-bg-calender';

      case 'PARENTALLEAVE':
        return 'parental-bg-calender';

      case 'HOLIDAY':
        return 'holiday-bg-calender';

      case 'COMPANYHOLIDAY':
        return 'holiday-bg-calender';

      case 'HOMEOFFICEEVENT':
        return 'homeoffice-bg-calender';

      case 'CAREERENTRYEVENT':
        return 'career-bg-calender';

      case 'ILLNESSREPRESENTATIONEVENT':
        return 'illnessrep-bg-calendar';

      case 'MEDICALBLOCKEREVENT':
        return 'event-blocker-bg';

      case 'STUDENTBLOCKEREVENT':
        return 'event-blocker-bg';

      case 'FLEXBLOCKEREVENT':
        return 'event-blocker-bg';

      case 'ILLNESSREPRESENTATIONFLEX':
        return 'illnessrep-bg-calendar';

      default:
        return '';
    }
  }

  //Fahrtzeitberechnung vom vorherigen Termin zum diesem Termin
  //async getBufferBefore(event: any, events:any, tempResource: number, currentStart: Date, currentDate: string){
  //  if(event.calculateTraveltime && this.traveltimeService.calcTraveltimeGlobal){
  //    const earlierEvents = events.filter((existing: any) => {
  //
  //    let sameResource;
  //
  //    if (!Array.isArray(existing.resource)){
  //      if(existing.resource === tempResource){
  //        sameResource = existing.resource;
  //      }
  //
  //    }else{
  //      sameResource = existing.resource.some((r: any) => r === tempResource);
  //    }
  //    currentStart = new Date(event.start)
  //    const existingStart = new Date(existing.start);
  //    const existingDate = existingStart.toISOString().split('T')[0];
  //    const isSameDay = existingDate === currentDate;
  //    const isEarlier = existingStart < currentStart;
  //
  //    return sameResource && isSameDay && isEarlier;
  //    });
  //
  //    const earlierEvent = earlierEvents.sort((a: { start: string | number | Date }, b: { start: string | number | Date }) => new Date(b.start).getTime() - new Date(a.start).getTime())[0];
  //    let previousEventLocation = earlierEvent?.location || null;
  //    let eventLocation = event.location
  //
  //    if(earlierEvent && earlierEvent.type !== 'MISSIONEVENT'){
  //      previousEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //    }
  //
  //    if(earlierEvent && earlierEvent.online){
  //      previousEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //    }
  //
  //    if(earlierEvent === undefined){
  //      previousEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //    }
  //
  //    if(event.online){
  //     eventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //    }
  //
  //    const bufferBefore = previousEventLocation ? await this.getBuffer(previousEventLocation, eventLocation) : null;
  //
  //    if(earlierEvent && (earlierEvent.calculateTraveltime || earlierEvent.bufferAfter)){
  //      const bufferObj = {
  //        previousEventLocation: previousEventLocation,
  //        earlierEvent: !!earlierEvent,
  //        bufferBefore: 0
  //      }
  //      return bufferObj
  //    } else{
  //      const bufferObj = {
  //        previousEventLocation: previousEventLocation,
  //        earlierEvent: !!earlierEvent,
  //        bufferBefore: bufferBefore
  //      }
  //      return bufferObj
  //    }
  //  }else{
  //
  //    const bufferObj = {
  //      previousEventLocation: '',
  //      earlierEvent: false,
  //      bufferBefore: null
  //   }
  //
  //    return   bufferObj
  //  }
  //}
  //
  //
  ////Fahrtzeitberechnung von diesem Termin zum nächsten Termin
  //async getBufferAfter(event: any, events:any, tempResource: number, currentStart: Date, currentDate: string){
  //  if(event.calculateTraveltime && this.traveltimeService.calcTraveltimeGlobal){
  //      const nextEvents = events.filter((existing: any) => {
  //
  //     let sameResource;
  //
  //      if (!Array.isArray(existing.resource)){
  //        if(existing.resource === tempResource){
  //          sameResource = existing.resource;
  //        }
  //
  //      }else{
  //        sameResource = existing.resource.some((r: any) => r === tempResource);
  //      }
  //      currentStart = new Date(event.start)
  //      const existingStart = new Date(existing.start);
  //      const existingDate = existingStart.toISOString().split('T')[0];
  //      const isSameDay = existingDate === currentDate;
  //      const isAfter = existingStart > currentStart;
  //
  //      return sameResource && isSameDay && isAfter;
  //      });
  //
  //    const nextEvent = nextEvents.sort((a: { start: string | number | Date; }, b: { start: string | number | Date; }) => new Date(a.start).getTime() - new Date(b.start).getTime())[0];
  //    let nextEventLocation = nextEvent?.location || null;
  //    let eventLocation = event.location
  //
  //    if(nextEvent && nextEvent.type !== 'MISSIONEVENT'){
  //      nextEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //    }
  //
  //     if(nextEvent && nextEvent.online){
  //       nextEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //     }
  //
  //    if(nextEvent === undefined){
  //      nextEventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //    }
  //
  //     if(event.online){
  //      eventLocation = 'Lina-Bommer-Weg 6, 51149 Köln';
  //     }
  //
  //    const bufferAfter = nextEventLocation ? await this.getBuffer(eventLocation, nextEventLocation) : null;
  //
  //    const bufferObj = {
  //      nextEventLocation: nextEventLocation,
  //      nextEvent: !!nextEvent,
  //      bufferAfter: bufferAfter
  //    }
  //
  //    return bufferObj
  //  }else{
  //
  //    const bufferObj = {
  //      nextEventLocation: '',
  //      nextEvent: undefined,
  //      bufferAfter: 0
  //   }
  //
  //    return   bufferObj
  //  }
  //}

  //Erstellen der TempEvents eines Events mit mehreren Resourcen
  async createTempEvent(event: any, events: any) {
    const refId = event.id;
    const results = await Promise.all(
      event.resource.map(async (tempResource: any, index: number) => {
        this.cdr.detectChanges;
        const currentStart = new Date(event.start);

        let previousEventLocation;
        let earlierEvent;
        let bufferBefore;

        let nextEventLocation;
        let nextEvent;
        let bufferAfter;

        if (
          event.calculateTraveltime &&
          this.traveltimeService.calcTraveltimeGlobal
        ) {
          const currentStart = new Date(event.start);

          const currentDate = currentStart.toISOString().split('T')[0];
          const bufferBeforeObj = await this.bufferService.getBufferBefore(
            event,
            events,
            tempResource,
            currentStart,
            currentDate,
          );
          const bufferAfterObj = await this.bufferService.getBufferAfter(
            event,
            events,
            tempResource,
            currentStart,
            currentDate,
          );

          previousEventLocation = (await bufferBeforeObj).previousEventLocation;
          earlierEvent = (await bufferBeforeObj).earlierEvent;
          bufferBefore = (await bufferBeforeObj).bufferBefore;

          nextEventLocation = (await bufferAfterObj).nextEventLocation;
          nextEvent = (await bufferAfterObj).nextEvent;
          bufferAfter = (await bufferAfterObj).bufferAfter;
        } else {
          bufferBefore = event.traveltimeBefore;
          bufferAfter = event.traveltimeAfter;
        }

        let platforms: OnlineLinkItem[] = [];

        platforms = this.normalizeOnlineLink(event.onlineLink);

        let informations;

        if (event.informations !== '') {
          informations = JSON.parse(event.informations);

          if (informations === null) {
            informations = '';
          } else if (informations.length === 0 && informations !== null) {
            informations = '';
          }
        } else {
          informations = '';
        }

        return {
          id: event.id + '-' + String(index + 1).padStart(2, '0'),
          refId: refId,
          isTempEvent: true,
          title: event.title,
          start: currentStart,
          end: new Date(event.end),
          location: event.location,
          previousEventLocation,
          nextEventLocation,
          hasEarlierSameDayEvent: !!earlierEvent,
          hastNextSameDayEvent: !!nextEvent,
          color: this.colorService.getStatusColor(event),
          description: event.description,
          cost: event.cost,
          status: event.status,
          category: event.category,
          resource: tempResource,
          type: event.type,
          customer: event.customer,
          createdAt: event.created_at,
          bestaetigungsform: event.bestaetigungsform,
          blocker: event.blocker,
          blockerRef: event.blockerRef,
          bufferAfter: bufferAfter,
          bufferBefore: bufferBefore,
          calculateTraveltime: event.calculateTraveltime,
          deleted: event.deleted,
          dialinTime: event.dialinTime,
          minuteBased: event.minuteBased,
          dolmetscher: event.dolmetscher,
          einsatzzeit: event.einsatzzeit,
          offeneTermine: event.offeneTermine,
          online: event.online,
          onlineLink: platforms,
          recurringids: event.recurringids,
          ticketno: event.ticketno,
          traveltime: event.traveltime,
          vorbereitungsmaterial: event.vorbereitungsmaterial,
          vorbereitungsmaterialLink: event.vorbereitungsmaterialLink,
          eventResources: event.resource,
          informations: informations,
          traveltimeBefore: event.traveltimeBefore,
          traveltimeAfter: event.traveltimeAfter,
          subtypes: event.subtypes,
          ueberprueft: event.ueberprueft,
          resourceMeta: event.resourceMeta,
          skillWarn: event.skillWarn,
          abrechnungArt: event.abrechnungArt,
          aufzeichnung: event.aufzeichnung,
          fremdCoAbrechnung: event.fremdCoAbrechnung,
        };
      }),
    );

    if (event.resource.length < event.dolmetscher) {
      // console.log('Ergebnisse :',results)
      this.filteredTasks = [...this.filteredTasks, ...results];
      this.tasks = [...this.tasks, ...results];
      // console.log('Tasks nach TempEvent Erstellung :',this.tasks)
      // console.log('Gefilterte Tasks nach TempEvent Erstellung :',this.filteredTasks)
    }

    results.map((tempEvent) => {
      //SKILL-SERVICE
      tempEvent.skillWarn =
        this.skillService.checkSkillsAndKundenteam(tempEvent);
    });

    // console.log('results TempEvents :',results)
    return results;
  }

  //Erstellen der TempEvents eines Events mit mehreren Resourcen
  async createTempEventWithoutBuffer(event: any, events: any) {
    const refId = event.id;
    const results = await Promise.all(
      event.resource.map(async (tempResource: any, index: number) => {
        this.cdr.detectChanges;
        const currentStart = new Date(event.start);

        let platforms: OnlineLinkItem[] = [];

        platforms = this.normalizeOnlineLink(event.onlineLink);

        let informations;

        if (event.informations !== '') {
          informations = JSON.parse(event.informations);

          if (informations === null) {
            informations = '';
          } else if (informations.length === 0 && informations !== null) {
            informations = '';
          }
        } else {
          informations = '';
        }

        return {
          id: event.id + '-' + String(index + 1).padStart(2, '0'),
          refId: refId,
          isTempEvent: true,
          title: event.title,
          start: currentStart,
          end: new Date(event.end),
          location: event.location,
          color: this.colorService.getStatusColor(event),
          description: event.description,
          cost: event.cost,
          status: event.status,
          category: event.category,
          resource: tempResource,
          type: event.type,
          customer: event.customer,
          createdAt: event.created_at,
          bestaetigungsform: event.bestaetigungsform,
          blocker: event.blocker,
          blockerRef: event.blockerRef,
          calculateTraveltime: event.calculateTraveltime,
          deleted: event.deleted,
          dialinTime: event.dialinTime,
          minuteBased: event.minuteBased,
          dolmetscher: event.dolmetscher,
          einsatzzeit: event.einsatzzeit,
          offeneTermine: event.offeneTermine,
          online: event.online,
          onlineLink: platforms,
          recurringids: event.recurringids,
          ticketno: event.ticketno,
          traveltime: event.traveltime,
          vorbereitungsmaterial: event.vorbereitungsmaterial,
          vorbereitungsmaterialLink: event.vorbereitungsmaterialLink,
          eventResources: event.resource,
          informations: informations,
          traveltimeBefore: event.traveltimeBefore,
          traveltimeAfter: event.traveltimeAfter,
          subtypes: event.subtypes,
          ueberprueft: event.ueberprueft,
          resourceMeta: event.resourceMeta,
          skillWarn: event.skillWarn,
        };
      }),
    );

    if (event.resource.length < event.dolmetscher) {
      // console.log('Ergebnisse :',results)
      this.filteredTasks = [...this.filteredTasks, ...results];
      this.tasks = [...this.tasks, ...results];
      // console.log('Tasks nach TempEvent Erstellung :',this.tasks)
      // console.log('Gefilterte Tasks nach TempEvent Erstellung :',this.filteredTasks)
    }

    results.map((tempEvent) => {
      //SKILL-SERVICE
      tempEvent.skillWarn =
        this.skillService.checkSkillsAndKundenteam(tempEvent);
    });

    // console.log('results TempEvents :',results)
    return results;
  }

  //Fahrzeitberechnungsfunktion über Google
  //async getBuffer(previousEventLocation: string, eventLocation: string): Promise<number | null> {
  //
  //  if (previousEventLocation !== '' && eventLocation !== ''){
  //    try {
  //      const data = await this.traveltimeService.getBufferBeforeWithGoogle(previousEventLocation, eventLocation);
  //
  //      if (data) {
  //        const distance = data.distance // Entfernung
  //        const duration = data.duration // Minuten
  //
  //        return duration;
  //      } else {
  //        console.warn('Travel data not available or status not OK.');
  //        return null;
  //      }
  //    } catch (error) {
  //
  //      console.error('Fehler bei getBuffer:', error);
  //      return null;
  //    }
  //  }else{
  //      return null
  //    }
  //
  //}

  //Erstellen der TempEvents eines Events mit mehreren Resourcen
  async createTempEventAfterUpdate(event: any, events: any) {
    const refId = event.id;
    const results = await Promise.all(
      event.resource.map(async (tempResource: any, index: number) => {
        this.cdr.detectChanges;
        let previousEventLocation;
        let earlierEvent;
        let bufferBefore;

        let nextEventLocation;
        let nextEvent;
        let bufferAfter;

        if (
          event.calculateTraveltime &&
          this.traveltimeService.calcTraveltimeGlobal
        ) {
          const currentStart = new Date(event.start);

          const currentDate = currentStart.toISOString().split('T')[0];
          const bufferBeforeObj = await this.bufferService.getBufferBefore(
            event,
            events,
            tempResource,
            currentStart,
            currentDate,
          );
          const bufferAfterObj = await this.bufferService.getBufferAfter(
            event,
            events,
            tempResource,
            currentStart,
            currentDate,
          );

          previousEventLocation = (await bufferBeforeObj).previousEventLocation;
          earlierEvent = (await bufferBeforeObj).earlierEvent;
          bufferBefore = (await bufferBeforeObj).bufferBefore;

          nextEventLocation = (await bufferAfterObj).nextEventLocation;
          nextEvent = (await bufferAfterObj).nextEvent;
          bufferAfter = (await bufferAfterObj).bufferAfter;
        } else {
          bufferBefore = event.traveltimeBefore;
          bufferAfter = event.traveltimeAfter;
        }
        const currentStart = new Date(event.start);

        let platforms: OnlineLinkItem[] = [];

        platforms = this.normalizeOnlineLink(event.onlineLink);

        let informations;

        if (event.informations !== '') {
          informations = JSON.parse(event.informations);

          if (informations === null) {
            informations = '';
          } else if (informations.length === 0 && informations !== null) {
            informations = '';
          }
        } else {
          informations = '';
        }

        let resourceMeta;

        if (typeof event.resourceMeta === 'string') {
          resourceMeta = JSON.parse(event.resourceMeta);
        } else {
          resourceMeta = event.resourceMeta;
        }

        return {
          id: event.id + '-' + String(index + 1).padStart(2, '0'),
          refId: refId,
          isTempEvent: true,
          title: event.title,
          start: currentStart,
          end: new Date(event.end),
          location: event.location,
          //previousEventLocation,
          //nextEventLocation,
          //hasEarlierSameDayEvent: !!earlierEvent,
          //hastNextSameDayEvent: !!nextEvent,
          color: this.colorService.getStatusColor(event),
          description: event.description,
          cost: event.cost,
          status: event.status,
          category: event.category,
          resource: tempResource,
          type: event.type,
          customer: event.customer,
          createdAt: event.created_at,
          bestaetigungsform: event.bestaetigungsform,
          blocker: event.blocker,
          blockerRef: event.blockerRef,
          bufferAfter: bufferAfter,
          bufferBefore: bufferBefore,
          calculateTraveltime: event.calculateTraveltime,
          deleted: event.deleted,
          dialinTime: event.dialinTime,
          minuteBased: event.minuteBased,
          dolmetscher: event.dolmetscher,
          einsatzzeit: event.einsatzzeit,
          offeneTermine: event.offeneTermine,
          online: event.online,
          onlineLink: platforms,
          recurringids: event.recurringids,
          ticketno: event.ticketno,
          traveltime: event.traveltime,
          vorbereitungsmaterial: event.vorbereitungsmaterial,
          vorbereitungsmaterialLink: event.vorbereitungsmaterialLink,
          eventResources: event.resource,
          informations: informations,
          traveltimeBefore: event.traveltimeBefore,
          traveltimeAfter: event.traveltimeAfter,
          subtypes: event.subtypes,
          ueberprueft: event.ueberprueft,
          resourceMeta: resourceMeta,
          skillWarn: false,
          fremdCoAbrechnung: event.fremdCoAbrechnung,
          abrechnungArt: event.abrechnungArt,
          aufzeichnung: event.aufzeichnung,
        };
      }),
    );

    if (event.resource.length < event.dolmetscher) {
      // console.log('Ergebnisse :',results)
      this.filteredTasks = [...this.filteredTasks, ...results];
      this.tasks = [...this.tasks, ...results];
      // console.log('Tasks nach TempEvent Erstellung :',this.tasks)
      // console.log('Gefilterte Tasks nach TempEvent Erstellung :',this.filteredTasks)
    }

    // console.log('results TempEvents :',results)

    results.map((tempEvent: any) => {
      //SKILL-SERVICE
      tempEvent['skillWarn'] =
        this.skillService.checkSkillsAndKundenteam(tempEvent);
    });

    return results;
  }

  getDatesForPrivateEvents(startOfDay: any) {
    const start = new Date(startOfDay);
    let startOfYear;
    let endOfYear;

    startOfYear = new Date(start);
    startOfYear.setMonth(startOfYear.getMonth() - 6);
    const year = startOfYear.getFullYear();
    const month = String(startOfYear.getMonth() + 1).padStart(2, '0');
    const day = String(startOfYear.getDate()).padStart(2, '0');
    startOfYear = `${year}-${month}-${day}`;

    endOfYear = new Date(start);
    endOfYear.setMonth(endOfYear.getMonth() + 6);
    const y = endOfYear.getFullYear();
    const m = String(endOfYear.getMonth() + 1).padStart(2, '0');
    const d = String(endOfYear.getDate()).padStart(2, '0');
    endOfYear = `${y}-${m}-${d}`;
    return { startOfYear, endOfYear };
  }

  //Abruf der Privaten Events
  async fetchPrivateEvents(startOfDay: any) {
    const { startOfYear, endOfYear } =
      this.getDatesForPrivateEvents(startOfDay);

    try {
      const privateEvents = await firstValueFrom(
        this.getEventService.fetchPrivate(startOfYear, endOfYear),
      );
      //console.log("Abgerufene PRIVATE EVENTS (roh):", privateEvents);

      const modifiedPrivateEvents = privateEvents.map((event: any) => {
        let cleanedObj;

        event.start = new Date(event.start);
        event.end = new Date(event.end);
        if (event.recurring) {
          if (event.recurring.until !== null) {
            const isoDate = event.recurring.until;
            const dateObj = new Date(isoDate);
            const year = dateObj.getFullYear();
            const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
            const day = dateObj.getDate().toString().padStart(2, '0');

            event.recurring.until = `${year}-${month}-${day}`;
          }

          if (event.recurring.until !== null) {
            event.condition = 'until';
          } else if (event.recurring.count) {
            event.condition = 'count';
          } else {
            event.condition = 'never';
          }
          const obj = event.recurring;

          cleanedObj = Object.fromEntries(
            Object.entries(obj).filter(([_, value]) => value !== null),
          );
        }

        if (Array.isArray(event.recurringException)) {
          event.recurringException = event.recurringException.map((d: string) =>
            d.slice(0, 10),
          );
        }

        delete event.onlineLink;
        delete event.informations;

        return {
          ...event,
          recurring: cleanedObj ?? event.recurring ?? null,
        };
      });

      //console.log("PRIVATE EVENTS mit neuem recurring:", modifiedPrivateEvents);

      const myPrivateEvents = modifiedPrivateEvents;
      const updatedIds = myPrivateEvents.map((e: { id: any }) => e.id);
      this.myEvents = this.myEvents.filter(
        (existing) => !updatedIds.includes(existing.id),
      );
      let matchingNewEvents = myPrivateEvents.filter((newEvent: { id: any }) =>
        updatedIds.includes(newEvent.id),
      );

      // let colorEvents = matchingNewEvents.filter((event: { title: string; }) => event.title === 'Homeoffice');
      //
      // colorEvents = colorEvents.map((event: any) => {
      //                 return {
      //                   ...event,
      //                   cssClass: 'homeoffice-bg-calender',
      //                   id: event.id
      //                 };
      //               });
      //
      // matchingNewEvents = matchingNewEvents.filter((event: { title: string; }) => event.title !== 'Homeoffice');
      // this.highlightedTimes = this.highlightedTimes.filter(
      //                           event => event.cssClass !== 'homeoffice-bg-calender'
      //                         );
      // this.highlightedTimes = [...this.highlightedTimes, ...colorEvents];
      this.myEvents = [...this.myEvents, ...matchingNewEvents];
    } catch (error) {
      console.error('Fehler beim Laden der privaten Events:', error);
    }
  }

  //Hilfsfunktion für fetchBlocker
  formatLocal(d: Date): string {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  //Hilfsfunktion für fetchBlocker
  formatForMobiscroll(dbDate: string): string {
    // Beispiel: "2025-09-09T00:00:00.000Z"
    return dbDate.replace('Z', '').substring(0, 16);
  }

  //Abruf der Blocker und je nach UserPermission, werden diese in Colors oder Invalids geschoben
  async fetchBlocker(startOfDay: any, endOfDay: any) {
    const formattedStart = this.formatLocal(new Date(startOfDay));
    const formattedEnd = this.formatLocal(new Date(endOfDay));

    this.getBlockerService.fetchBlocker(formattedStart, formattedEnd).subscribe(
      (events) => {
        if (this.permissionService.userPermission === 'admin') {
          //Blocker (Colors) für Admins
          this.blockerInvalids = events.map((event: any) => {
            return {
              text: event.title,
              start: event.start,
              end: event.end,
              cssClass: 'blocker-bg-calender-admin',
              resource: event.resource,
              type: 'Blocker',
              id: event.id,
            };
          });

          this.highlightedTimes = [
            ...this.highlightedTimes,
            ...this.blockerInvalids,
          ];
          this.updateCalendarOptions();
        } else {
          //Blocker für User
          this.blockerInvalids = events.map((event: any) => {
            return {
              id: event.id,
              title: event.title,
              start: event.start,
              end: event.end,
              type: event.type,
              blocker: event.blocker,
              blockerRef: event.blockerRef,
              deleted: event.deleted,
              recurringids: event.recurringids,
              cssClass: event.cssClass,
              resource: event.resource,
            };
          });

          const ruhezeitInvalids = this.userResttimes.map((r) => ({
            start: r.start,
            end: r.end,
            resource: r.resource,
            cssClass: r.cssClass,
            text: r.text,
          }));

          // Beides kombinieren
          this.invalids = [...this.blockerInvalids, ...ruhezeitInvalids];
          this.invalidsCopy = this.invalids;
          this.updateCalendarOptions();
        }
      },
      (error) => {
        console.error('Fehler beim Abrufen der Event-Daten:', error);
      },
    );
  }

  closePopup() {
    // console.log(this.myEvents);
    this.myEvents = this.myEvents.filter(
      (e) => !String(e.id).startsWith('mbsc_'),
    );
    if (this.inst?.instance) {
      const tempEvents = this.inst.instance
        .getEvents()
        .filter((e: any) => String(e.id).startsWith('mbsc_'));

      tempEvents.forEach((temp: any) => {
        this.inst.instance.removeEvent(temp.id);
      });
    }

    this.onDateChange(this.selectedDate);
    this.isPopupOpen = false;
    this.cdr.detectChanges();
  }

  checkInvalid(event: any) {
    const isInvalid = this.invalids.some((invalidPeriod) => {
      if (
        Array.isArray(invalidPeriod.resource) &&
        invalidPeriod.resource.includes(event.resource)
      ) {
        if (
          invalidPeriod.start instanceof Date &&
          !isNaN(invalidPeriod.start.valueOf()) &&
          invalidPeriod.end instanceof Date &&
          !isNaN(invalidPeriod.end.valueOf())
        ) {
          const eventStart = new Date(event.start).getTime();
          const eventEnd = new Date(event.end).getTime();
          const invalidStart = new Date(invalidPeriod.start).getTime();
          const invalidEnd = new Date(invalidPeriod.end).getTime();
          return (
            (eventStart >= invalidStart && eventStart < invalidEnd) ||
            (eventEnd > invalidStart && eventEnd <= invalidEnd) ||
            (eventStart <= invalidStart && eventEnd >= invalidEnd)
          );
        } else {
          return false; // ungültige Daten
        }
      } else {
        return false; // keine passende Resource
      }

      // 🔒 WICHTIG: Standardrückgabe, falls keine der Bedingungen greift
      return false;
    });

    if (isInvalid) {
      this.toastService.dangerToast(
        'Dieses Datum liegt in einem Blocker. Bitte wählen Sie einen anderen Zeitraum.',
      );
      return false;
    }

    return true;
  }

  //Tritt beim Laden der Resourcenbilder ein Fehler auf, wird der src string geleert.
  onImageError(id: number) {
    this.myResources = this.myResources.map((resource) => {
      if (resource.id === id) {
        resource.img = '';
      }
      return resource;
    });
  }

  openFilters() {
    if (!this.anchorElm || !this.anchorElm.nativeElement) {
      console.warn('⚠️ anchorElm fehlt – openFilters() abgebrochen');
      return;
    }

    if (
      !this.filterResourcesPopup ||
      typeof this.filterResourcesPopup.openFilters !== 'function'
    ) {
      console.warn('⚠️ filterResourcesPopup fehlt – openFilters() abgebrochen');
      return;
    }

    this.popupAnchor = this.anchorElm.nativeElement;
    this.filterResourcesPopup.openFilters(this.popupAnchor);
  }

  // Event wird im Backlog gespeichert
  async moveToBacklog(event: any) {
    if (!event) {
      console.error('Fehler: Kein gültiges Event vorhanden!');
      return;
    }

    // 🔑 WICHTIG: IMMER mit einer Kopie arbeiten
    const backlogEvent = structuredClone(event);

    // -------------------------------
    // Ressourcen behandeln
    // -------------------------------
    const oldResource = backlogEvent.resource;
    backlogEvent.resource = [];

    if (backlogEvent.recurring === undefined) {
      backlogEvent.recurring = null as any;
    }

    // -------------------------------
    // Customer normalisieren
    // -------------------------------
    if (Array.isArray(backlogEvent.customer)) {
      backlogEvent.customer = backlogEvent.customer
        .map((c: any) => (typeof c === 'object' ? c.id : c))
        .filter(
          (id: any) => id != null && id !== '' && Number.isFinite(Number(id)),
        )
        .map((id: any) => Number(id));
    } else if (
      backlogEvent.customer &&
      typeof backlogEvent.customer === 'object'
    ) {
      backlogEvent.customer = [backlogEvent.customer.id];
    } else if (!backlogEvent.customer) {
      backlogEvent.customer = [];
    }

    // -------------------------------
    // Event-Resources berechnen
    // -------------------------------
    let updatedResourceIds: any[] = [];

    if (Array.isArray(backlogEvent.eventResources)) {
      if (
        backlogEvent.eventResources.length === 1 &&
        backlogEvent.eventResources[0] === oldResource
      ) {
        updatedResourceIds = [];
      } else {
        updatedResourceIds = backlogEvent.eventResources.filter(
          (id: any) => id !== oldResource,
        );

        if (updatedResourceIds.length === 0) {
          updatedResourceIds = [];
        }
      }
    } else {
      updatedResourceIds = [];
    }

    // -------------------------------
    // Informationsfeld normalisieren
    // -------------------------------
    backlogEvent.informations = JSON.stringify(backlogEvent.informations);

    // -------------------------------
    // Backend-Update
    // -------------------------------
    this.pendingUpdates.set(backlogEvent.id, Date.now());

    await this.putEventFetchService
      .updateEvent(
        backlogEvent.title,
        backlogEvent['location'],
        backlogEvent['notes'],
        backlogEvent.start,
        backlogEvent.end,
        updatedResourceIds,
        backlogEvent['description'],
        backlogEvent['status'],
        backlogEvent['ticketno'],
        backlogEvent.customer,
        backlogEvent['category'],
        backlogEvent['id'],
        backlogEvent.color,
        backlogEvent['cost'],
        backlogEvent['type'],
        backlogEvent['online'],
        backlogEvent['onlineLink'],
        backlogEvent['dolmetscher'],
        backlogEvent['vorbereitungsmaterial'],
        backlogEvent['vorbereitungsmaterialLink'],
        backlogEvent['bufferBefore'],
        backlogEvent.bufferAfter,
        backlogEvent['traveltime'],
        false,
        backlogEvent['isTemplate'],
        backlogEvent.recurring,
        backlogEvent.recurringException,
        backlogEvent.dialinTime,
        backlogEvent.minuteBased,
        backlogEvent.subtypes,
        backlogEvent.informations,
        backlogEvent.traveltimeBefore,
        backlogEvent.traveltimeAfter,
        backlogEvent['einsatzzeit'],
        backlogEvent['bestaetigungsform'],
        backlogEvent['aufzeichnung'],
        backlogEvent['vorbereitung'],
        backlogEvent['vorbereitungZeit'],
        backlogEvent['abrechnungArt'],
        backlogEvent['fremdCoAbrechnung'],
        backlogEvent['ueberprueft'],
        backlogEvent['resourceMeta'],
      )
      .subscribe({
        next: (response: any) => {
          //console.log('RESPONSE EVENT:', response);

          // 🔓 LOCK entfernen
          this.pendingUpdates.delete(response.id);

          // ✅ DAS ist dein "local update"
          this.processUpdatedEvent(response, 'local');

          // UI Feedback
          this.popupCloseAfterEventUpdate = true;
          setTimeout(() => (this.popupCloseAfterEventUpdate = false));
        },
        error: (err: any) => {
          console.error('Update failed:', err);

          // ❗ wichtig → lock freigeben
          this.pendingUpdates.delete(backlogEvent.id);
        },
      });

    // -------------------------------
    // Events neu laden
    // -------------------------------
    const endDate = new Date(backlogEvent.start);
    endDate.setHours(23, 59, 59, 999);

    const startString = this.formatTimeStampToDate(backlogEvent.start);
    const endString = this.formatTimeStampToDate(endDate);

    //await this.fetchEvents(startString, endString);

    // -------------------------------
    // UI-Feedback
    // -------------------------------
    this.popupCloseAfterMoveEventToBacklog = true;
    setTimeout(() => (this.popupCloseAfterMoveEventToBacklog = false));

    this.toastService.warningToast('Termin in Backlog verschoben');
  }

  //Event wird als Template gespeichert
  async moveToTemplate(event: any) {
    const myId = this.getUserId();
    if (!event) {
      console.error('Fehler: Kein gültiges Event vorhanden!');
      return;
    }

    const startDate = new Date(event.start);
    const endDate = new Date(event.end);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    const startTimestamp = startDate.getTime();
    const endTimestamp = endDate.getTime();

    // Neue Kopie erzeugen, damit Kalender-Event erhalten bleibt
    const templateEvent = structuredClone(event);
    templateEvent.isTemplate = 1;
    templateEvent.resource = undefined;

    // Neue ID vergeben (damit nicht dieselbe wie im Kalender)
    templateEvent.id = 'template-' + Date.now();

    // 👉 onlineLink als JSON-String erzwingen
    const onlineLinkString =
      templateEvent.onlineLink != null
        ? JSON.stringify(templateEvent.onlineLink)
        : '';

    if (Array.isArray(templateEvent.customer)) {
      templateEvent.customer = templateEvent.customer
        .map((c: any) => (typeof c === 'object' ? c.id : c))
        .filter(
          (id: any) => id != null && id !== '' && Number.isFinite(Number(id)),
        )
        .map((id: any) => Number(id));
    } else if (
      templateEvent.customer &&
      typeof templateEvent.customer === 'object'
    ) {
      templateEvent.customer = [templateEvent.customer.id];
    } else if (!templateEvent.customer) {
      templateEvent.customer = [];
    }

    this.postEventFetchService
      .uploadTemplate(
        templateEvent.start,
        templateEvent.end,
        templateEvent.title,
        templateEvent.location,
        templateEvent.cost,
        templateEvent.description,
        templateEvent.category,
        templateEvent.status,
        templateEvent.ticketno,
        templateEvent.customer,
        templateEvent.color,
        templateEvent.vorbereitungsmaterial,
        templateEvent.vorbereitungsmaterialLink,
        templateEvent.online,
        onlineLinkString,
        templateEvent.buffeBefore,
        templateEvent.bufferAfter,
        templateEvent.traveltime,
        false,
        templateEvent.type,
        templateEvent.isTemplate,
        templateEvent.traveltimeBefore,
        templateEvent.traveltimeAfter,
        templateEvent.informations,
        templateEvent.aufzeichnung,
        templateEvent.vorbereitung,
        templateEvent.vorbereitungZeit,
        templateEvent.abrechnungArt,
        templateEvent.fremdCoAbrechnung,
        templateEvent.bestaetigungsform,
      )
      .subscribe({
        next: (response: any) => {
          if (myId === response.authorId) {
            this.sidebar.processNewTemplate(response, 'local');
          }
        },
        error: (err: any) => {
          console.error('Create failed:', err);
        },
      });

    // await this.fetchTemplates(); // neu laden
    await this.fetchEvents(startTimestamp, endTimestamp);
    this.toastService.warningToast('Termin in Vorlagen kopiert');
  }

  //Öffnet das gewählte Event aus dem Backlog im Popup.
  openBacklogEvent(args: any) {
    this.tempEvent = args;
    this.tempEvent['onlineLink'] = this.normalizeOnlineLink(
      this.tempEvent['onlineLink'],
    );
    this.selectedSegment = args['type'] || 'MISSIONEVENT';
    this.showTabContainer = false;
    this.showHistoryContainer = false;
    this.sharedEventPopup.open('onBacklogClick');
  }

  openEventWithId(args: any) {
    this.getHistoryData(args.id);
    this.tempEvent = args;
    this.tempEvent['informations'] = JSON.parse(this.tempEvent['informations']);
    this.tempEvent['onlineLink'] = this.normalizeOnlineLink(
      this.tempEvent['onlineLink'],
    );
    this.selectedSegment = args['type'] || 'MISSIONEVENT';
    this.showTabContainer = false;
    this.showHistoryContainer = true;
    this.sharedEventPopup.open('onEventClick');
    this.cdr.detectChanges();
  }

  async getHistoryData(id: any) {
    if (!id) return;

    try {
      const data = await this.eventHistoryService
        .fetchEventHistory(id)
        .toPromise();

      const nullOrEmptyFields = [
        'vorbereitungsmaterialLink',
        'description',
        'category',
        'onlineLink',
        'dolmetscher',
        'ticketno',
        'vorbereitungsmaterial',
      ];

      const excludedFields = [
        'color',
        'blocker',
        'blockerRef',
        'bufferAfter',
        'bufferBefore',
        'calculateTraveltime',
        'cost',
        'dialinTime',
        'id',
        'minuteBased',
        'offeneTermine',
        'recurringException',
        'subtypes',
        'traveltime',
        'traveltimeAfter',
        'traveltimeBefore',
        'recurring',
      ];

      this.historyData = data.filter((entry: any) => {
        if (excludedFields.includes(entry.fieldName)) return false;

        if (
          entry.fieldName === 'customer' &&
          entry.fieldValueFrom === '0' &&
          entry.fieldValueTo === '[]'
        ) {
          return false;
        }

        if (
          entry.fieldName === 'vorbereitungsmaterial' &&
          entry.fieldValueFrom === 'false' &&
          entry.fieldValueTo === '"0"'
        ) {
          return false;
        }

        if (
          nullOrEmptyFields.includes(entry.fieldName) &&
          (((entry.fieldValueFrom === '""' ||
            entry.fieldValueFrom === 'null') &&
            (entry.fieldValueTo === '""' || entry.fieldValueTo === 'null')) ||
            ((entry.fieldValueFrom === 'null' ||
              entry.fieldValueFrom === '0') &&
              (entry.fieldValueTo === 'null' || entry.fieldValueTo === '0')) ||
            ((entry.fieldValueFrom === 'null' ||
              entry.fieldValueFrom === 'false') &&
              (entry.fieldValueTo === 'null' ||
                entry.fieldValueTo === 'false')))
        ) {
          return false;
        }

        if (['start', 'end'].includes(entry.fieldName)) {
          try {
            const fromDate = new Date(JSON.parse(entry.fieldValueFrom));
            const toDate = new Date(JSON.parse(entry.fieldValueTo));

            const fromTime =
              fromDate.getUTCHours() * 60 + fromDate.getUTCMinutes();
            const toTime = toDate.getUTCHours() * 60 + toDate.getUTCMinutes();

            if (fromTime === toTime) {
              return false;
            }
          } catch (e) {
            console.warn('Fehler beim Datum-Vergleich:', e);
          }
        }

        return true;
      });

      //console.log('History-Data (gefiltert):', this.historyData);
      this.groupHistoryEntries();
    } catch (err) {
      console.error('Fehler beim Laden der Historie:', err);
    }
  }

  groupHistoryEntries() {
    const map = new Map();

    for (const entry of this.historyData) {
      const timestamp = this.formatTimestamp(entry.changeDate);
      const user = entry.kuerzel || entry.userID || 'Unbekannt';
      const key = `${timestamp}|${user}`;

      if (!map.has(key)) {
        map.set(key, {
          timestamp: entry.changeDate,
          user: user,
          entries: [],
          open: false,
        });
      }

      map.get(key).entries.push(entry);
    }

    this.groupedHistory = Array.from(map.values()).sort((a, b) => {
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
    });
  }

  formatTimestamp(date: string) {
    const d = new Date(date);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d.toISOString();
  }

  async formatDateToString(date: any) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  //Hier werden die heutigen Events und diese vom Vortag über die Enduhrzeit auf Ruhezeiten überprüft
  appendResttime(todayEvents: any[], startOfDay: any) {
    this.userResttimes = [];
    this.adminResttimes = [];
    this.highlightedTimes = [...this.highlightedTimes];

    //Kategorien OHNE Ruhezeit
    let noResttimeCategories = ['Nur Arzttermine', 'Berufseinstiegsphase'];

    // Vortag berechnen
    const selected = new Date(startOfDay);
    const startOfPrevDay = new Date(selected);
    startOfPrevDay.setDate(selected.getDate() - 1);
    const year = startOfPrevDay.getFullYear();
    const month = String(startOfPrevDay.getMonth() + 1).padStart(2, '0');
    const day = String(startOfPrevDay.getDate()).padStart(2, '0');
    const startOfPrevDayString = `${year}-${month}-${day}`;
    const endOfPrevDay = startOfPrevDayString;

    const eventsByResource = new Map<string, any[]>();

    //Events nach Resource sortieren
    todayEvents.forEach((event) => {
      if (noResttimeCategories.includes(event.category)) return;

      if (event.type === 'MISSIONEVENT') {
        event.onlineLink = this.normalizeOnlineLink(event.onlineLink);

        const resourceIds: string[] = Array.isArray(event.resource)
          ? event.resource
              .map((r: any) => r?.id ?? r)
              .filter((r: any) => r != null)
          : event.resource != null
            ? [event.resource?.id ?? event.resource]
            : [];

        //console.log(this.myResources);

        resourceIds.forEach((resourceId) => {
          const resource = this.myResources.find(
            (r: any) => String(r.id) === String(resourceId),
          );

          if (
            ['Allgemein', 'Intern', 'Abrechnung', 'Fremddolmetscher'].includes(
              resource?.team ?? '',
            )
          )
            return;

          if (!resourceId) return;
          if (!eventsByResource.has(resourceId)) {
            eventsByResource.set(resourceId, []);
          }
          eventsByResource.get(resourceId)!.push(event);
        });
      }
    });

    //Pro Resource den **letzten** gültigen Event nach 20 Uhr finden
    eventsByResource.forEach((events, resourceId) => {
      const filteredEvents = events.filter((event) => {
        const end = new Date(event.end);
        const hour = end.getHours();
        const minutes = end.getMinutes();

        // Prüfen, ob für diese Resource stunden = 1 gesetzt ist
        const hasStundenRelevanz = event.resourceMeta?.some(
          (meta: any) =>
            String(meta.id) === String(resourceId) && meta.stunden === 1,
        );

        return (
          (hour > 20 || (hour === 20 && minutes >= 1)) &&
          event.type !== 'ILLNESSREPRESENTATIONEVENT' &&
          event.type !== 'HOLIDAYEVENT' &&
          event.type !== 'SICKEVENT' &&
          event.type !== 'PRIVATEEVENT' &&
          hasStundenRelevanz
        );
      });

      if (filteredEvents.length === 0) return;

      // Finde den **letzten** Termin (nach Endzeit sortiert)
      const latestEvent = filteredEvents.reduce((latest, current) => {
        return new Date(current.end).getTime() > new Date(latest.end).getTime()
          ? current
          : latest;
      });

      const end = new Date(latestEvent.end);

      //Fahrtzeitverlängerung, wenn auto. Fahrtzeitberechnung an.
      let ruheStart: Date;
      ruheStart = new Date(end);
      ruheStart.setMinutes(ruheStart.getMinutes() + 1);

      let ruheEnd: Date;

      if (latestEvent.traveltimeAfter && !latestEvent.calculateTraveltime) {
        //BUFFERTIME WHEN TRAVELTIME
        const traveltimeToOffice = latestEvent.traveltimeAfter;

        //START RUHEZEIT
        ruheStart = new Date(ruheStart);
        const startHours = ruheStart.getHours();
        const startMinutes = ruheStart.getMinutes();
        //const startMinutes = ruheStart.getMinutes() + traveltimeToOffice;

        ruheStart.setHours(startHours, startMinutes);

        //ENDE RUHEZEIT
        ruheEnd = new Date(ruheStart);
        const endHours = ruheEnd.getHours() + 13;
        //const endMinutes = ruheEnd.getMinutes() + traveltimeToOffice;

        ruheEnd.setHours(endHours);
      } else if (
        latestEvent.calculateTraveltime &&
        !latestEvent.traveltimeAfter
      ) {
        //BUFFERTIME WHEN CALCULATE AUTO
        const buffer = latestEvent.bufferAfter;

        //START RUHEZEIT
        ruheStart = new Date(ruheStart);
        const startHours = ruheStart.getHours();
        //const startMinutes = ruheStart.getMinutes() + buffer;
        const startMinutes = ruheStart.getMinutes();
        ruheStart.setHours(startHours, startMinutes);

        //ENDE RUHEZEIT
        ruheEnd = new Date(ruheStart);
        const endHours = ruheEnd.getHours() + 13;
        //const endMinutes = ruheEnd.getMinutes() + traveltimeToOffice;

        ruheEnd.setHours(endHours);
      } else {
        ruheEnd = new Date(ruheStart);
        ruheEnd.setHours(ruheEnd.getHours() + 13);
      }

      //Ruhezeitobjekt erstellen
      const ruhezeit = {
        start: ruheStart,
        end: ruheEnd,
        resource: latestEvent.resource,
        text: 'Ruhezeit',
        cssClass: 'resttime-bg-calender',
        type: 'resttime',
      };

      //Permissioncheck
      if (this.permissionService.userPermission === 'admin') {
        this.adminResttimes.push(ruhezeit);
      } else {
        this.userResttimes.push(ruhezeit);
      }
    });

    //Highlight oder Invalid je nach Rolle
    if (this.permissionService.userPermission === 'admin') {
      const ruhezeitColors = this.adminResttimes.map((r) => ({
        start: r.start,
        end: r.end,
        resource: r.resource,
        cssClass: r.cssClass,
        text: r.text,
        type: 'resttime',
      }));

      const today = this.selectedDate;

      // Hilfsfunktion, um nur das Datum zu vergleichen (ohne Uhrzeit)
      const isSameDate = (date1: Date, date2: Date) => {
        return (
          date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate()
        );
      };

      // Filtert alle Einträge raus, deren start-Datum heute ist
      this.highlightedTimes = this.highlightedTimes.filter((item) => {
        const startDate = new Date(item.start);

        // Wenn Event kein resource hat oder type oder cssClass mit homeoffice → immer behalten
        if (!item.resource) return true;
        if (item.type === 'Blocker') return true;
        if (item.cssClass === 'homeoffice-bg-calender') return true;
        if (item.cssClass === 'illnessrep-bg-calendar') return true;
        if (item.cssClass === 'event-blocker-bg') return true;
        if (item.cssClass === 'parental-bg-calender') return true;
        if (item.cssClass === 'holiday-bg-calender') return true;
        if (item.cssClass === 'career-bg-calender') return true;
        // Ansonsten: nur behalten, wenn nicht heute
        return !isSameDate(startDate, today);
      });

      //neue Werte anhängen
      this.highlightedTimes = [...this.highlightedTimes, ...ruhezeitColors];
    } else {
      const ruhezeitInvalids = this.userResttimes.map((r) => ({
        start: r.start,
        end: r.end,
        resource: r.resource,
        cssClass: r.cssClass,
        text: r.text,
        type: 'resttime',
      }));

      const today = new Date();

      // Hilfsfunktion, um nur das Datum zu vergleichen (ohne Uhrzeit)
      const isSameDate = (date1: Date, date2: Date) => {
        return (
          date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate()
        );
      };

      // Filtert alle Einträge raus, deren start-Datum heute ist
      this.invalids = this.invalids.filter((item) => {
        if (!item.start) return true; // Falls kein Startdatum vorhanden, Eintrag behalten
        if (item['type'] === 'Blocker') return true;

        let startDate: Date;

        if (item.start instanceof Date) {
          startDate = item.start;
        } else if (
          typeof item.start === 'string' ||
          typeof item.start === 'number'
        ) {
          startDate = new Date(item.start);
        } else {
          // Wenn das Format unbekannt ist, sicherheitshalber behalten
          return true;
        }

        return !isSameDate(startDate, today);
      });

      // Neue Einträge hinzufügen
      this.invalids = [...this.invalids, ...ruhezeitInvalids];
      this.updateCalendarOptions();
    }
  }

  //Hier wird geprüft, ob beim erstellen oder ändern eines Termins eine Ruhezeit gesetzt werden muss und ein Termin am nächsten Tag in dieser Rihezeit liegt.
  // Wenn ja, wird eine Warnung ausgegeben.
  async checkNextDayEvents(event: any): Promise<boolean> {
    const selected = new Date(this.startOfDay);

    const startOfNextDay = new Date(selected);
    startOfNextDay.setDate(startOfNextDay.getDate() + 1);
    const year = startOfNextDay.getFullYear();
    const month = String(startOfNextDay.getMonth() + 1).padStart(2, '0');
    const day = String(startOfNextDay.getDate()).padStart(2, '0');
    const startOfNextDayString = `${year}-${month}-${day}`;
    const endOfNextDay = startOfNextDayString;

    try {
      const nextDayMainEvents = await firstValueFrom(
        this.getEventService.fetchEvents(startOfNextDayString, endOfNextDay),
      );

      let nextDayTempEvents: any[] = [];

      for (let mainEvent of nextDayMainEvents) {
        if (Array.isArray(mainEvent.resource)) {
          const created = await this.createTempEventWithoutBuffer(
            mainEvent,
            nextDayMainEvents,
          );
          if (Array.isArray(created)) {
            nextDayTempEvents.push(...created);
          } else if (created) {
            nextDayTempEvents.push(created);
          }
        }
      }

      nextDayMainEvents.filter((ev: any) => {
        Array.isArray(ev.resource);
      });

      let combinedNextDayEvents = [...nextDayMainEvents, ...nextDayTempEvents];
      // Falls keine Events am nächsten Tag existieren → kein Konflikt
      if (!combinedNextDayEvents || combinedNextDayEvents.length === 0) {
        return false;
      }

      const end = new Date(event.end);
      const hour = end.getHours();
      const minutes = end.getMinutes();

      // Nur prüfen, wenn Event spät endet (nach 20:01 Uhr)
      if (hour > 20 || (hour === 20 && minutes >= 1)) {
        const ruheStart = new Date(end);
        ruheStart.setMinutes(ruheStart.getMinutes() + 1);

        const ruheEnd = new Date(ruheStart);
        ruheEnd.setHours(ruheEnd.getHours() + 13);

        const conflict = combinedNextDayEvents.some((e: any) => {
          const res = Array.isArray(e.resource) ? e.resource[0] : e.resource;
          const nextDayResource = Array.isArray(event.resource)
            ? event.resource[0]
            : event.resource;
          const sameResource = res === nextDayResource;

          if (!sameResource) return false;

          const eventStart = new Date(e.start);
          return eventStart < ruheEnd;
        });

        if (
          conflict &&
          ![
            'HOLIDAYEVENT',
            'SICKEVENT',
            'ILLNESSREPRESENTATIONEVENT',
            'PRIVATEEVENT',
          ].includes(event.type)
        ) {
          this.toastService.alertToast(
            `Event in der Ruhezeit!`,
            'Da dieses Event nach 20:00 Uhr startet, wird autom. eine Ruhezeit eingeplant. In dieser Ruhezeit liegt bereits ein Event am Folgetag.',
          );
          return true;
        }
      }

      return false; // Kein Konflikt
    } catch (err) {
      console.error('Fehler beim Laden der Events für den nächsten Tag', err);
      return false; // Bei Fehler auch lieber false zurückgeben, statt die App crashen zu lassen
    }
  }

  //Holt alle Events und updated die TempEvents
  async getNextUpcomingEvent(updatedEvent: any) {
    let allEvents = await firstValueFrom(
      this.getEventService.fetchEvents(this.startOfDay, this.endOfDay),
    );
    for (const event of allEvents) {
      this.updateTempEvents(event);
    }
  }

  normalizeOnlineLink(
    onlineLink: string | OnlineLinkItem[] | null | undefined,
  ): OnlineLinkItem[] {
    // null/undefined -> leeres Array
    if (!onlineLink) {
      return [];
    }

    // Schon ein Array -> alle Einträge absichern
    if (Array.isArray(onlineLink)) {
      return onlineLink.map((item) => ({
        platform: item.platform || 'Link',
        link: item.link || '',
        description: item.description || '',
      }));
    }

    // String -> versuchen zu parsen
    if (typeof onlineLink === 'string') {
      try {
        const parsed = JSON.parse(onlineLink);

        if (Array.isArray(parsed)) {
          // jedes Objekt absichern
          return parsed.map((item: any) => ({
            platform: item.platform || 'Link',
            link: item.link || '',
            description: item.description || '',
          }));
        } else {
          // falsches Format -> als einzelner Link behandeln
          return [
            {
              platform: 'Link',
              link: onlineLink,
              description: '',
            },
          ];
        }
      } catch {
        // Fallback: war ein alter String-Link (nur URL)
        return [
          {
            platform: 'Link',
            link: onlineLink,
            description: '',
          },
        ];
      }
    }

    // Sicherheits-Fallback
    return [];
  }

  deleteEventFromLib(event: any) {
    this.myEvents = this.myEvents.filter((item) => item.id !== event.id);

    if (!event.isTempEvent && typeof event.id === 'string') {
      //OUTLOOK EVENT
      const resource = this.myResources.find((resource) =>
        Array.isArray(event.resource)
          ? event.resource[0] === resource.id
          : event.resource === resource.id,
      );

      const resourceO365Id = resource?.o365Id;
      const eventId = event.id;
      this.deleteEventFetchService
        .deleteExternEvent(eventId, resourceO365Id)
        .then((res) => {
          //console.log('Event gelöscht:', res);
          this.popupCloseAfterEventDelete = true;
          setTimeout(() => (this.popupCloseAfterEventDelete = false));
        });
    } else {
      this.deleteEventFetchService
        .deleteEvent(event)
        .then((res) => {
          //console.log('Event gelöscht:', res);
          this.popupCloseAfterEventDelete = true;
        })
        .then()
        .catch((err) => console.error('Fehler beim Löschen:', err));

      setTimeout(() => (this.popupCloseAfterEventDelete = false));
    }
  }

  deleteEventAfterCancelFromLib() {
    this.myEvents = [...(this.myEvents || [])];
  }

  postEventFromLib(event: any) {
    const myId = this.getUserId();
    if (!event) return;

    event.ticketno = Number(event.ticketno ?? 0);

    this.postEventFetchService
      .uploadEvent(
        event.start,
        event.end ?? '',
        event.title ?? '',
        event.location ?? '',
        event.cost ?? 0,
        event.description ?? '',
        event.category ?? '',
        event.status ?? '',
        event.ticketno ?? 0,
        event.customer ?? null,
        event.resource ?? [],
        event.color ?? '',
        event.online ?? false,
        JSON.stringify(event.onlineLink ?? null),
        event.vorbereitungsmaterial ?? null,
        event.vorbereitungsmaterialLink ?? null,
        event.bufferBefore ?? 0,
        event.bufferAfter ?? 0,
        event.traveltime ?? 0,
        event.calculateTraveltime ?? false,
        event.type ?? '',
        event.isTemplate ?? false,
        event.recurring ?? null,
        event.recurringException ?? null,
        event.dialinTime ?? null,
        event.minuteBased ?? false,
        event.subtypes ?? null,
        event.informations ?? null,
        event.traveltimeBefore ?? 0,
        event.traveltimeAfter ?? 0,
        event.dolmetscher ?? 0,
        event.einsatzzeit ?? null,
        event.bestaetigungsform ?? null,
        event.aufzeichnung ?? null,
        event.vorbereitung ?? null,
        event.vorbereitungZeit ?? null,
        event.abrechnungArt ?? null,
        event.fremdCoAbrechnung ?? null,
      )
      .subscribe({
        next: (response: any) => {
          //console.log('POST RESPONSE:', response);

          if (response.authorId === myId) {
            this.processNewEvent(response, 'local');
            this.dateChangeService.setSelectedDate(event.start);
          }

          this.popupCloseAfterEventPost = true;

          this.toastService.successToast('Termin angelegt');
        },
        error: (err) => {
          console.error('Create failed:', err);
        },
      });
  }

  updateEventHistoryFromLib(data: any) {
    if (!data || data.length < 2 || !this.tempEvent?.id) {
      return;
    }

    this.eventHistoryService.compareAndUploadChanges(
      data[0],
      data[1],
      this.tempEvent.id,
      'changed',
    );
  }

  getUserId() {
    const userData = localStorage.getItem('authUser');

    if (userData) {
      // nur wenn userData nicht null
      const parsedData = JSON.parse(userData);
      const userId =
        parsedData.id == undefined ? parsedData.user.id : parsedData.id;
      //console.log('USER_ID:', userId);
      return userId;
    } else {
      console.warn('Kein User(ID) im localStorage gefunden');
    }
  }

  updateEventFromLib(event: any) {
    event.ticketno = Number(event.ticketno);

    if (event.isTempEvent) {
      event.id = event.refId;
    }

    const id = event.id;

    // 🔒 LOCK setzen (JETZT korrekt)
    this.pendingUpdates.set(id, Date.now());

    this.putEventFetchService
      .updateEvent(
        event.title,
        event.location,
        event.notes,
        event.start,
        event.end,
        event.resource,
        event.description,
        event.status,
        event.ticketno,
        event.customer,
        event.category,
        event.id,
        event.color,
        event.cost,
        event.type,
        event.online,
        JSON.stringify(event.onlineLink),
        event.dolmetscher,
        event.vorbereitungsmaterial,
        event.vorbereitungsmaterialLink,
        event.bufferBefore,
        event.bufferAfter,
        event.traveltime,
        event.calculateTraveltime,
        event.isTemplate,
        event.recurring,
        event.recurringException,
        event.dialinTime,
        event.minuteBased,
        event.subtypes,
        JSON.stringify(event.informations),
        event.traveltimeBefore,
        event.traveltimeAfter,
        event.einsatzzeit,
        event.bestaetigungsform,
        event.aufzeichnung,
        event.vorbereitung,
        event.vorbereitungZeit,
        event.abrechnungArt,
        event.fremdCoAbrechnung,
        event.ueberprueft,
        event.resourceMeta,
      )
      .subscribe({
        next: (response: any) => {
          //console.log('RESPONSE EVENT:', response);

          // 🔓 LOCK entfernen
          this.pendingUpdates.delete(response.id);

          // ✅ DAS ist dein "local update"
          this.processUpdatedEvent(response, 'local');

          // UI Feedback
          this.popupCloseAfterEventUpdate = true;
          //setTimeout(() => (this.popupCloseAfterEventUpdate = false));
          this.toastService.successToast('Termin aktualisiert');
        },
        error: (err) => {
          console.error('Update failed:', err);

          // ❗ wichtig → lock freigeben
          this.pendingUpdates.delete(id);
        },
      });
  }

  onSidebarEventSelected(eventData: { start: Date; end: Date }): void {
    this.highlightedTimes = this.highlightedTimes || [];

    this.highlightedTimes = this.highlightedTimes.filter(
      (item) => item.background !== '#ffeeba',
    );

    const highlightColor = '#ffeeba';
    const newHighlight = {
      start: eventData.start,
      end: eventData.end,
      background: highlightColor,
      cssClass: 'highlighted-selection',
    };

    this.highlightedTimes = [...this.highlightedTimes, newHighlight];
    this.updateCalendarOptions();
  }

  async getCustomerSearchFromLib(filterText: any) {
    try {
      const data =
        await this.getCustomerService.fetchCustomerSearch(filterText);

      const foundCustomers: any[] = [];
      if (data) {
        //console.log('CUSTOMERS FOUND -->', data);
        for (const customer of data) {
          const customerName = customer.firstname + ' ' + customer.lastname;
          foundCustomers.push({ text: customerName, value: customer.id });
        }
        this.filteredCustomers = foundCustomers;
      }
      return this.filteredCustomers;
    } catch (err) {
      console.error('Fehler bei fetchCustomerSearch:', err);
      this.filteredCustomers = [];
      return [];
    }
  }

  handleEventFilterChange(filter: any[]) {
    if (!filter || filter.length === 0) {
      this.myEvents = [...this.myEventsCopy];
      this.highlightedTimes = [...this.highlightedTimesCopy];
      this.invalids = [...this.invalidsCopy];
      return;
    }

    const typeSet = new Set<string>();
    const categorySet = new Set<string | null>();
    const statusSet = new Set<string | null>();

    filter.forEach((f) => {
      if (f === null) {
        // null kann Kategorie ODER Status sein → beide erlauben
        categorySet.add(null);
        //statusSet.add(null);
      } else if (f.group === 'Typ') {
        typeSet.add(f.value);
      } else if (this.isStatusValue(f.value)) {
        statusSet.add(f.value);
      } else {
        categorySet.add(f.value);
      }
    });

    //true = bleibt
    //false = raus
    this.myEvents = this.myEventsCopy.filter((event) => {
      const hasCategoryFilter = categorySet.size > 0;
      const hasStatusFilter = statusSet.size > 0;

      /* ---------- Typ ---------- */
      if (typeSet.size > 0 && !typeSet.has(event['type'])) {
        return false;
      }

      /* ---------- Kategorie ---------- */
      if (hasCategoryFilter) {
        // Nur Typen mit Kategorie zulassen
        if (event['type'] !== 'MISSIONEVENT') {
          return false;
        }

        // Kategorie muss matchen (inkl. null)
        if (!categorySet.has(event['category'])) {
          return false;
        }
      }

      /* ---------- Status ---------- */
      if (hasStatusFilter) {
        if (event['isTempEvent'] === true) {
          const result = event['resourceMeta'].find(
            (r: any) => r.id === event.resource,
          );

          if (!result || !statusSet.has(result.status)) {
            return false;
          }
        } else {
          if (!statusSet.has(event['status'])) {
            return false;
          }
        }
      }

      return true;
    });

    this.highlightedTimes = this.highlightedTimes.filter((event) => {
      if (!event['type']) {
        return;
      }

      const hasCategoryFilter = categorySet.size > 0;
      const hasStatusFilter = statusSet.size > 0;

      if (hasCategoryFilter || hasStatusFilter) {
        return false;
      }

      /* ---------- Typ ---------- */
      //Wenn Typ Filter aktiv && Typ des Events nicht enthalten --> Event entfernen
      if (typeSet.size > 0 && !typeSet.has(event['type'])) {
        return false;
      }

      return true;
    });

    this.invalids = this.invalids.filter((event) => {
      if (!event['type']) {
        return;
      }

      const hasCategoryFilter = categorySet.size > 0;
      const hasStatusFilter = statusSet.size > 0;

      if (hasCategoryFilter || hasStatusFilter) {
        return false;
      }

      /* ---------- Typ ---------- */
      //Wenn Typ Filter aktiv && Typ des Events nicht enthalten --> Event entfernen
      if (typeSet.size > 0 && !typeSet.has(event['type'])) {
        return false;
      }

      return true;
    });
  }

  private isStatusValue(value: string): boolean {
    return [
      'Reserviert',
      'Gebucht',
      'Abgesagt',
      'Rechnung offen',
      'Überprüft',
      'Abgerechnet',
      'Verplant',
    ].includes(value);
  }

  postEventFromExtern(event: any) {
    const myId = this.getUserId();
    this.postEventFetchService
      .uploadEvent(
        event.start,
        event.end,
        event.title,
        event['location'],
        event['cost'],
        event['description'],
        event['category'],
        event['status'],
        event['ticketno'],
        event['customer'],
        event['resource'],
        event.color,
        event['online'],
        JSON.stringify(event['onlineLink']),
        event['vorbereitungsmaterial'],
        event['vorbereitungsmaterialLink'],
        event['buffeBefore'],
        event['bufferAfter'],
        event['traveltime'],
        event['calculateTraveltime'],
        event['type'],
        event['isTemplate'],
        event.recurring,
        event.recurringException,
        event['dialinTime'],
        event['minuteBased'],
        event['subtypes'],
        event['informations'],
        event['traveltimeBefore'],
        event['traveltimeAfter'],
        event['dolmetscher'],
        event['einsatzzeit'],
        event['bestaetigungsform'],
        event['aufzeichnung'],
        event['vorbereitung'],
        event['vorbereitungZeit'],
        event['abrechnungArt'],
        event['fremdCoAbrechnung'],
      )
      .subscribe({
        next: (response: any) => {
          //console.log('POST RESPONSE:', response);

          if (response.authorId === myId) {
            this.processNewEvent(response, 'local');
          }

          this.popupCloseAfterEventPost = true;
          setTimeout(() => (this.popupCloseAfterEventPost = false));

          this.selectedDate = event.start;
          this.toastService.successToast('Termin angelegt');
        },
        error: (err) => {
          console.error('Create failed:', err);
        },
      });
  }

  resourceIsExtern(event: any) {
    const isExtern = event?.resource
      ? Array.isArray(event.resource)
        ? event.resource.some((r: any) => this.extResources.includes(r))
        : this.extResources.includes(event.resource)
      : false;
    return isExtern;
  }

  handlePendingUpdate(update: { id: number; timestamp: number }) {
    this.pendingUpdates.set(update.id, update.timestamp);
  }

  handleUpdateSuccess(id: number) {
    this.pendingUpdates.delete(id);
  }

  //DRAG COLORS SETZEN
  setDragColors(event: any) {
    const customers = event.customer;
    const allKundenteamIds = this.skillService.getAllKundenteamIds(customers);

    const allowedColor = {
      resource: allKundenteamIds,
      background: '#1aff001c',
      start: new Date(new Date(event.start).setHours(0, 0, 0, 0)),
      end: new Date(new Date(event.end).setHours(23, 59, 59, 999)),
      type: 'allowed',
    };

    this.highlightedTimes = [...this.highlightedTimes, allowedColor];
  }

  //DRAG COLORS ZURÜCKSETZEN
  resetDragColors(event: any) {
    this.highlightedTimes = this.highlightedTimes.filter(
      (color) => color.type !== 'allowed',
    );
  }

  //ERROR FILTER
  filterMyEventsByError(filterIds: any, filterName: string) {
    this.myEvents = this.myEvents.filter((event) => {
      if (filterName === 'Nicht gebucht') {
        return (
          filterIds.includes(event.id) ||
          (filterIds.includes(event['refId']) &&
            !event['resourceMeta']?.some(
              (meta: any) =>
                meta.id === event.resource && meta.status === 'Gebucht',
            ))
        );
      }

      return filterIds.includes(event.id) || filterIds.includes(event['refId']);
    });
    this.cdr.detectChanges();
  }

  resetErrorFilter() {
    this.myEvents = this.myEventsCopy;
    this.cdr.detectChanges();
  }
}

function formatForMobiscrolle(start: any) {
  throw new Error('Function not implemented.');
}
